/* eslint-disable prettier */
/**
 * KO file
 */

import {
	roles,
	daySelection,
	GARoleTypeId,
	toggleCCPEntityDetail,
	readinessReportCategories,
	archiveReportQualifiedTypeId,
	natureOfEngagements,
	dashboardTabId,
	dashboardViews as dashboardViewsConstants,
	accountDesignations,
	groupRiskStatus,
	riskTypeIds
} from '../util/uiconstants';

export const labels = {
	clearFilter: '모두 처리',
	canvasOversight: 'Canvas Oversight',
	oversight: '감독',
	canvasLabel: 'Canvas',
	myProjects: '내 프로젝트',
	otherProjects: '다른 프로젝트',
	priorProjects: '전기 프로젝트',
	completedProjects: '완료된 프로젝트',
	completedLabel: '완료됨',
	createProject: '프로젝트 생성',
	rollForward: 'Roll forward',
	rollForwardLabel: 'Roll forward',
	rollForwardTitle: '프로젝트 roll forward',
	project: '프로젝트',
	openProject: '프로젝트 열기',
	manageUsers: '사용자 관리',
	rollForwardInstructionalText: '프로젝트를 roll forward하시겠습니까? <br> 그러면 신규 프로젝트를 생성할 때 완료된 프로젝트를 템플릿으로 사용할 수 있습니다. 다음 정보가 roll forward됩니다: 프로젝트 이름, 조직도, 그룹, 그룹 관리자.',
	isClientUserError: '활성 프로젝트가 없습니다. 프로젝트에 초대받으려면 EY 팀 멤버와 얘기하십시오.',
	activeProjects: '활성 프로젝트',
	myActiveProjects: '내 활성 프로젝트',
	otherActiveProjects: '다른 활성 프토젝트',
	myCompletedProjects: '내 완료 프로젝트',
	myActiveProjectsPlaceholder: '여기에 열거된 EY Canvas Oversight 프로젝트에 접근할 수 있습니다. 프로젝트를 열려면 프로젝트 이름을 선택하고 세부정보를 보려면 개수를 클릭하시오.',
	deleteProject: '프로젝트 삭제',
	deleteProjectModalText: '이 프로젝트를 삭제하시겠습니까?<br>프로젝트는 랜딩 페이지에서 제거되고 모든 팀 멤버가 더 이상 접근할 수 없습니다.',
	createButton: '프로젝트 생성',
	search: '검색',
	searchEngagement: 'Engagement 검색',
	searchEngagements: 'Engagement 검색',
	searchEntitiesAndEngagements: '기업 및 engagement 검색',
	searchClientList: '고객 이름 검색',
	noDataFound: '표시할 데이터가 없습니다',
	expand: '확장',
	collapse: '축소',
	more: '기타',
	options: '옵션',
	editProject: '프로젝트 편집',
	manageTeam: '팀 관리',
	markAsCompleted: '완료 표시',
	connectedTo: '연결된 대상',
	connectedClients: '연결된 고객',
	connectedToClients: (count) => `${count} ${count == 1 ? 'client' : 'clients'}`,
	connectedToEngagements: (count) => `Engagements: ${count == 0 ? 'None' : count}`,
	countEngagements: (count) => `${count} ${count === 1 ? 'engagement' : 'engagements'}`,
	connectToEngagements: (count) => `Connect ${count} ${count == 1 ? 'engagement' : 'engagements'}`,
	connectedToAccessGroups: (count) => `Connected to ${count} ${count == 1 ? 'group' : 'groups'}`,
	connectToAccessGroups: (count) => `Connect ${count} ${count == 1 ? 'group' : 'groups'}`,
	entitiesLabelForCount: (count) => `${count} ${count == 1 ? 'Entity' : 'Entities'}`,
	viewsLabelForCount: (count) => `${count} ${count == 1 ? 'View' : 'Views'}`,
	domainsLabelForCount: (count) => `${count} ${count == 1 ? 'Domain' : 'Domains'}`,
	viewsLabelWithoutCount: (count) => `${count == 1 ? 'View' : 'Views'}`,
	domainsLabelWithoutCount: (count) => `${count == 1 ? 'Domain' : 'Domains'}`,
	engagement: 'Engagement',
	engagementNameLabel: 'Engagement 이름',
	engagementPartnerLabel: 'Engagement Partner',
	partnerLabel: 'Partner',
	notInvited: '초대되지 않음',
	clientNameLabel: '고객 이름',
	client: '고객',
	codeLabel: '코드',
	idLabel: 'ID',
	engagements: 'Engagement',
	engagementsLabel: 'Engagement',
	noResultsFound: '결과를 찾을 수 없습니다',
	submit: '제출',
	saveAndContinue: '저장 & 계속',
	savecontinue: '저장 & 계속',
	saveDraft: '초안 저장',
	closeLabel: '닫기',
	step1: '단계 1',
	step2: '단계 2',
	step3: '단계 3',
	step4: '단계 4',
	step5: '단계 5',
	adminsNoneLabel: '없음',
	domainsAllLabel: '모두',
	adminsHeaderLabel: '관리:',
	domainsHeaderLabel: '도메인:',
	moreCountLabel: '+ {0}',
	selectClient: '고객 선택',
	createOrgChart: '조직도 생성',
	connnectToCanvas: 'EY Canvas에 연결',
	viewSummary: '요약 보기',
	viewLabel: '보기',
	cancelLabel: '취소',
	required: '필수',
	filter: '필터',
	filtersWarningMessage: '필터 한도를 초과했습니다. 한 번에 25개 필터만 적용할 수 있습니다.',
	back: '뒤로',
	save: '저장',
	saveClose: '저장 & 닫기',
	continue: '계속',
	finish: '마침',
	saveChanges: '변경사항 저장',
	projectName: '프로젝트 이름',
	projectOwners: '프로젝트 소유자',
	addAnotherProjectOwner: '다른 프로젝트 소유자 추가',
	duplicateOwnerAdded: '중복 사용자',
	step1InstructionHeader: '시작하려면 프로젝트 이름을 입력한 후, 추가 프로젝트 소유자를 추가하고 아래 목록에서 고객을 하나 이상 선택하십시오',
	step1SubInstructionPart1: `아래에서 고객 이름을 보려면 고객 GIS, GFIS, Mercury 코드에 접근권한이 있어야 합니다. 이 단계에서 선택한 고객에 대해 프로젝트에 연결할 수 있는 EY Canvas engagement를 확인합니다. EY Canvas Oversight 사용법에 대해 자세히 알아보려면, {link}을(를) 확인하십시오.`,
	step2InstructionHeader: '프로젝트를 위해 조직도를 생성하십시오.',
	step2SubInstructionPart1: '조직도는 고객이 사업을 관리하는 방식을 반영해야 합니다. 이는 프로젝트에 연결하는 EY Canvas engagement 데이터를 요약하고 내부 및 외부 팀 멤버 접근권한을 관리하는 데 사용됩니다.',
	here: '여기',
	zoomIn: '확대',
	zoomOut: '축소',
	expandAll: '모두 확장',
	collapseAll: '모두 축소',
	addLabel: '추가',
	editLabel: '편집',
	removeLabel: '제거',
	noRowsTemplateStringPart1: '고객 접근권한이 없습니다.',
	noRowsTemplateStringPart2: '을(를) 클릭하여 접근 방법에 대해 더 알아보십시오.',
	noRowSelected: '계속하려면 고객을 하나 이상 선택하십시오',
	firstName: '이름',
	lastName: '성',
	displayLanguage: '표시 언어',
	numberFormat: '숫자 형식',
	dateFormat: '날짜 형식',
	timezone: '시간대',
	theme: '테마',
	chooseDisplayTheme: '기본 표시 테마를 선택하십시오',
	light: '라이트',
	dark: '다크',
	usersettings: '사용자 설정',
	userOptions: '사용자 옵션',
	clearHoverText: '처리',
	noFiltersAvailable: '사용 가능한 필터 없음',
	dashboard: '대시보드',
	milestones: 'Milestone',
	activityFeed: '활동 피드',
	keyEvents: '주요 이벤트',
	keyEventCompletion: '주요 이벤트 완료',
	canvasClientPortal: 'Canvas Client Portal',
	canvasClientPortalEy: 'EY Canvas Client Portal',
	groupAudit: '그룹감사',
	projectManagement: '프로젝트 관리',
	reporting: '보고',
	insights: '인사이트',
	groupRiskAssessment: '그룹 위험 평가',
	internal: '내부',
	external: '외부',
	members: '멤버',
	show: '표시',
	showDetails: '세부정보 표시',
	showMore: '더 표시',
	showLess: '덜 표시',
	clientName: '고객 이름',
	clientsLabel: '고객',
	clientLabel: '고객',
	source: '원천',
	code: '코드',
	accessDelegatedBy: '접근권한 위임자',
	returnToPreviousStep: '이전 단계로 돌아가기',
	backButtonWarning: '이전 단계로 돌아가 변경하면, 이 단계 진행상황에 영향을 미칠 수 있습니다.<br> 이전 단계로 돌아가려면 <b>계속</b>을 선택하고 이 단계에 남으려면 <b>취소</b>를 선택하십시오.',
	step1SubInstructionPart3: '이 단계에서 고객을 선택하면 프로젝트를 연결하는 데 어느 EY Canvas engagement를 사용 가능한지 확인할 수 있습니다',
	step3InstructionHeader: 'EY Canvas engagement를 하나 이상 선택한 후 조직도에 끌어서 놓으십시오',
	step3InstructionPara: '조직도 상 EY Canvas engagement와 기업 간 연결은 프로젝트 대시보드에 EY Canvas 데이터를 요약하는 방식을 결정합니다',
	availableLabel: '사용 가능',
	connectedLabel: '연결됨',
	milestoneSummaryView: 'Milestone - 요약 보기',
	taskCompletionByMilestone: 'Milestone별 task 완료',
	basedOnTaskCompletition: 'Task 완료 기준',
	scopeAndStrategy: '범위 및 전략',
	execution: '실행',
	conclusion: '결론',
	step3ListDefaultMessage: '단계 1에서 선택한 고객에 사용 가능한 engagement가 없습니다. 계속하려면 단계 1로 돌아가 다른 고객을 선택하십시오.',
	addNewEngagementLabel: '신규 engagement 추가',
	selectedLabel: '선택됨',
	moreText: '기타',
	connectLabel: '연결',
	connectEngagements: '연결된 engagement',
	connectToAnEngagement: '시작하려면 engagement를 연결하십시오',
	connectToAnAccessGroup: '그룹이 연결되지 않았습니다',
	tasks: 'Task',
	organizationalChartHeading: '기업',
	groupAdministratorsLabel: '그룹 관리자',
	step4InstructionHeader: '프로젝트 그룹을 생성하고 이를 조직도에 있는 기업 하나 이상에 연결하십시오.',
	step4ImportantNote: '중요 노트: 그룹 멤버는 그룹을 연결한 조직도 기업과 그 기업의 종속기업에 대해 EY Canvas engagement 데이터를 볼 수 있습니다. 조직도 상 지배기업에 그룹을 연결하면, 그룹은 지배기업과 모든 종속기업에 대해 EY Canvas engagement 데이터를 볼 수 있습니다',
	addAGroup: '그룹 추가',
	addGroup: '그룹 추가',
	searchGroup: '그룹 검색',
	addNewGroupHeader: '여기에 신규 그룹을 생성하십시오',
	editNewGroupHeader: '여기에서 기존 그룹을 편집하십시오',
	addNewGroupInstruction: '프로젝트를 생성한 후, 내부 및 외부 팀 멤버를 이 그룹에 초대할 수 있습니다. 그룹 관리자를 추가할 수 있으며 그룹 관리자도 이 그룹에 멤버를 초대할 수 있습니다.',
	groupName: '그룹 이름',
	groupAdministrators: '그룹 관리자 (선택사항)',
	groupAdministratorsSubHeading: '그룹 관리자를 초대하십시오. 그룹 관리자는 프로젝트를 생성한 후 멤버를 초대할 수 있습니다. 그룹 관리자는 이 그룹의 화면과 도메인을 편집할 수 없습니다.',
	clearAllValues: '처리',
	createGroupDashboardViews: '대시보드 보기',
	dashboardViewsSubHeading: '보기를 하나 이상 선택하십시오. 그러면 멤버가 프로젝트 대시보드에서 볼 수 있는 데이터가 결정됩니다.',
	duplicateDomain: '도메인 복제',
	allMilestones: '모든 Milestone',
	someMilestonesSelected: '{0} milestone 선택됨',
	noGroupsAdded: '이 프로젝트에 도메인이 추가되지 않았습니다',
	step5InstructionHeader: 'EY Canvas Oversight 프로젝트를 검토하십시오',
	step5SubInstruction: '변경해야 한다면 편집 연필을 선택하여 이전 단계로 돌아가십시오. <b>이전 단계를 변경하면 다음 단계 진행상황이 영향받을 수 있습니다.</b>',
	associationNotRequired: '연결 필요하지 않음',
	accessGroupAlreadyAddedToParent: '선택한 그룹 중 하나 이상을 지배기업에 이미 연결했습니다. 접근 그룹이 지배기업에 연결되어 있다면 그 멤버는 지배기업과 모든 종속기업의 EY Canvas engagement 데이터를 볼 수 있습니다. 따라서, 연결은 필요하지 않습니다.',
	deleteGroupInstructionalText: '이 그룹을 삭제하시겠습니까? <br> 삭제 후에는 작업을 실행 취소할 수 없습니다. 그룹 멤버는 귀하의 프로젝트에 더 이상 접근할 수 없습니다.',
	deleteGroup: '그룹 삭제',
	removeMember: '멤버 제거',
	removeMemberTitle: '이 팀 멤버를 제거하시겠습니까? 멤버가 여러 그룹에 속한 경우, 여기에 열거된 모든 그룹에서 제거되며 이 프로젝트에 더 이상 접근할 수 없습니다. 멤버를 단일 그룹에서만 제거하려면, 대신 <b>편집<b/> 옵션을 선택하십시오.',
	teamMember: '팀 멤버',
	clientNameLbl: '고객',
	help: '지원',

	//Org char left rail
	filters: '필터',
	countEngagementSelected: 'Engagement {1}개 중 {0}개 선택됨',
	of: '{num} of',
	entityName: '기업 이름',
	enterEntityName: '여기에 이름을 입력하십시오',
	projectOwner: '프로젝트 소유자',
	role: '역할',
	domains: '도메인 (선택사항)',
	domainSubHeading: '외부 팀 멤버를 이 그룹에 초대하려면, 도메인을 하나 이상 추가하십시오. 도메인은 이메일 주소에서 @ 기호 뒤에 있는 문자를 나타냅니다. 외부 팀 멤버를 추가하려면, 이 그룹에 유효한 도메인이 있어야 합니다.',
	addAdministrator: '그룹 관리자 추가',
	addNewDomain: '신규 도메인 추가',
	addExistingDomain: '기존 도메인 추가',
	placeholderStep3NoEngagementMessage: '단계 1에서 선택한 고객에 사용 가능한 engagement가 없습니다. 계속하려면 단계 1로 돌아가 다른 고객을 선택하십시오.',
	placeholderStep3NoConnectedEngagementMessage: '연결된 engagement가 없습니다',
	placeholderStep3AllEngagementsConnected: '사용 가능한 engagement가 모두 귀하의 프로젝트에 연결됩니다',
	placeholderStep4NoConnectedGroupMessage: '아직 연결된 그룹이 없습니다',
	domainName: '도메인 이름',
	engagementLabel: 'Engagement',
	start: '시작',
	end: '종료',
	suggestedEnd: '권장 종료',
	status: '상태',
	thereIsNoDataToDisplay: '표시할 데이터가 없습니다',
	selectadditionalEntitiesToContinue: '계속하려면 기업을 추가로 선택하십시오',
	comingSoonToDisplay: '부문 상태가 곧 제공됩니다',
	checkForUpdatesToDisplay: '몇 주 안에 업데이트를 다시 확인하십시오',
	userSearchPlaceholder: '결과를 보려면 이름이나 이메일을 입력하고 Enter 키를 누르십시오',
	userSearchPlaceholderForExternal: '이메일을 입력하고 Enter 키를 눌러 결과를 보십시오',
	partnerInChargeInvitedToTheEngagement: 'Partner in charge가 engagement에 초대됐습니다',
	partnerInChargeSignedOffOnCraSummary: 'Partner in charge가 CRA 요약에 sign-off했습니다',
	eqrSignedOffOnCraSummary: 'EQR이 CRA 요약에 sign-off했습니다',
	partnerInChargeSignedOffOnAuditPlan: 'Partner in charge가 감사 계획에 sign-off했습니다',
	picInvited: 'PIC 초대됨',
	picSignOffCRA: 'CRA에 PIC sign-off',
	picSignOffAuditPlan: '감사 계획에 PIC sign-off',
	eqrSingOffCRA: 'CRA에 EQR sign-off',
	overdue: '지연',
	outOf: 'out of',
	edit: '편집',
	remove: '제거',
	add: '추가',
	admin: '관리',
	views: '보기',
	domainLabel: '도메인',
	domainslabel: '도메인',
	viewLabelText: '보기',
	viewsLabelText: '보기',
	administrators: '관리자',
	none: '없음',
	organizationChart: '조직도',
	invalidDomainName: '유효하지 않은 도메인 이름',
	lastRefreshed: '최근 새로 고침',
	lastRefreshedActivityFeed: 'Activity feed data last refreshed',
	lastRefreshedReconciliation: '조정 데이터 최근 새로 고침',
	quickFilter: '빠른 필터',
	notApplied: '미적용',
	quickFilterInput: '빠른 필터 이름',
	quickFilterSubHeaderText: '마치고 나면, 데이터를 보려는 기업을 각각 선택하지 않고도 빠른 필터를 적용하여 선별할 수 있습니다',
	createFilterTrigger: '신규 필터 생성',
	createFilterTitle: '신규 빠른 필터 생성',
	createFilterButton: '빠른 필터 생성',
	createFilterHeaderText: '빠른 필터를 생성하려면 조직도 기업을 하나 이상 선택하십시오',
	createFilterSubHeaderText: '마치고 나면, 데이터를 보려는 기업을 각각 선택하지 않고도 빠른 필터를 적용하여 선별할 수 있습니다',
	editFilterTitle: '빠른 필터 편집',
	editFilterHeaderText: '빠른 필터 편집 또는 삭제',
	editFilterIconTitleTip: '편집',
	oneRequired: '하나 이상 선택해야 합니다',
	noFiltersCreatedTitle: '생성된 빠른 필터 없음',
	noFiltersCreatedSubTitle: '시작하려면 빠른 필터를 생성하십시오',
	clear: '처리',
	completionRange: '완료 범위',
	engagementCount: 'Engagement 개수',
	clickOnAVisualBelowToFilterTheEngagementList: 'Engagement 목록을 필터링하려면 아래를 클릭하십시오.',
	organizationalChartTooltip: '조직도를 선택하여 귀하의 Oversight Project에서  기업을 편집하거나 제거하십시오',
	organizationalChart: '조직도',

	//Task status chart labels
	open: '처리 전',
	inProgress: '진행 중',
	inReview: '리뷰 중',
	completeUpperCase: '완료',
	taskStatusOverdue: '지연',
	noDataForSelections: '선택사항에 사용 가능한 데이터가 없습니다',
	selectOneOrMoreMilestones: '계속하려면 다른 milestone을 하나 이상 선택하십시오',
	milestoneDetailTitle: 'Milestone - 세부정보',
	taskStatusByMilestone: 'Milestone별 task 상태',
	milestoneDetailSubtitle: 'Task 상태 기준',
	basedOnAllTasksForTheSelectedMilestone: '선택한 milestone에 대한 모든 task 기준',
	totalTasks: '총 task',
	noneSelected: '선택한 항목 없음',
	nameOrEmail: '이름 또는 이메일',
	remove: '제거',
	milestonesTooltipText: 'Milestone별 감사 진행상황',
	canvasClientPortalTooltipText: '요청 상태. 만료 도래, 지연, 반송 항목 포함.',
	groudAuditTooltipText: 'Primary 및 부문 팀 상태. 반송, 지연 항목 포함.',
	projectManagementTooltipText: '리뷰노트 및 배정 상태, 지연 항목 포함. 이 보기는 고객에게 보이지 않습니다.',
	insightsTootipText: 'Primary와 부문 팀 간 위험, 실증절차, 통제 전략, 발견사항 비교. 이 보기는 고객에게 보이지 않습니다.',
	reportTootipText: '국가별 보고서 준비, 수정, task 완료 상태',
	taskStatusComplete: 'Task 상태 - 완료',
	taskStatusInreview: 'Task 상태 - 리뷰 중',
	taskStatusInprogress: 'Task 상태 - 진행 중',
	taskStatusOpen: 'Task 상태 - 처리 전',

	//Review Notes chart labels
	reviewNotesByStatusTitle: '모든 리뷰노트',
	byStatus: '상태별',
	totalNotes: '총 노트',
	totalNotesLabel: '총 노트',
	openNotes: '처리 전 노트',
	byPriority: '우선순위별',
	cleared: '처리됨',
	closed: '닫힘',
	low: 'Low',
	medium: 'Medium',
	high: 'High',
	critical: 'Critical',
	notesTableTooltipContent: '처리 전 상태인 노트에 따름',

	// Group audit
	groupAuditTotalForms: '총 양식',
	groupAuditNotSent: '미전송',
	groupAuditUnlinked: '링크 해제됨',
	totalTasksCapitalized: '총 task',
	primary: 'Primary',
	component: '부문',

	//Bar chart
	are: 'are',
	complete: '완료',
	noMilestoneDataForSelection: '이 감사 단계에 표시할 milestone 데이터가 없습니다',
	selectDifferentAuditPhase: '계속하려면 다른 감사 단계를 선택하거나 기업을 추가로 선택하십시오.',

	//Delegate
	delegateInstruction: "다른 팀 멤버에게 접근권한을 위임하여 귀하 대신 프로젝트를 생성하도록 합니다. 시작하려면 팀 멤버 이름이나 이메일 주소를 입력하십시오. 대리인은 귀하가 접근할 수 있는 모든 고객에 접근할 수 있습니다.",

	delegateAccess: '대리인 관리',
	addAnother: '대리인 추가',
	hideMyDelegate: '내 대리인 숨기기',
	showMyDelegate: '내 대리인 표시',
	noRecord: '결과를 찾을 수 없습니다',
	duplicateUser: '대리인으로 이미 추가됨',
	duplicateUserMessage: '사용자로 이미 추가됨',
	addDelegates: '대리인 추가',
	delegateTo: '위임받은 사람',
	delegateFrom: '위임한 사람',
	delegateToMsg: '귀하의 접근권한을 팀 멤버에게 위임하지 않았습니다',
	delegateFromMsg: '귀하에게 접근권한을 위임한 팀 멤버가 없습니다',

	// Project dashboard left rail
	searchFilterPlaceholder: '필터 검색',
	searchEntitiesPlaceholder: '기업 검색',
	outOfEngagements: '<b>{1}</b> engagement 중 <b>{0}</b>',
	engagementCompletedBasedOnTaskCompletion: '<b>{0}</b> engagement는 task 완료 기준으로 <b>{1}</b> 완료됐습니다',
	engagementsCompletedBasedOnTaskCompletion: '<b>{0}</b> engagement는 task 완료 기준으로 <b>{1}</b> 완료됐습니다',
	engagementCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagement는 <b>{1}</b>의 task가 완료됐습니다',
	engagementsCompletedBasedOnTaskCompletionReporting: '<b>{0}</b> engagement는 <b>{1}</b>의 task가 완료됐습니다',
	engagementCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagement는 이 milestone에 대해 <b>{1}</b>의 task가 완료됐습니다',
	engagementsCompletedBasedOnTaskCompletionMilestone: '<b>{0}</b> engagement는 이 milestone에 대해 <b>{1}</b>의 task가 완료됐습니다',
	reportReleaseDate: '보고서 발행일',
	partnerInvited: 'Partner 초대됨',
	picSignoffOnCra: 'CRA에 PIC sign-off',
	eqrSignoffOnCra: 'CRA에 EQR sign-off',
	picSignoffOnAuditPlan: '감사 계획에 PIC sign-off',
	overdueLabel: '지연',

	//Team members
	teamMembersTitle: '팀 멤버',
	membersTitle: '멤버',
	eyContactsTitle: 'EY 연락처',
	allMembersLabel: '모든 멤버',
	internalMembersLabel: '내부 멤버',
	externalMembersLabel: '외부 멤버',
	groupsTitle: '내 그룹',
	projectOwnersTitle: '프로젝트 소유자',
	projectOwnersLabel: '프로젝트 소유자',
	projectOwnerLabel: '프로젝트 소유자',

	//CCP
	summary: '요약',
	requestsByStatus: '상태별 요청사항',
	totalRequests: '총 요청사항',
	totalRequestsTitle: '총 요청사항',
	receivedByEy: 'EY가 수신함',
	acceptedByEy: 'EY가 수락함',
	outstandingByEy: '처리 전',
	returned: '반송됨',
	receivedByEyOnTime: 'EY가 적시에 수신함',
	averageDaysOverdue: '평균 지연 기간',
	outOfReceivedAndAccepted: '{0}/{1} 수신 및 수락된 요청사항',
	outOfStandingRequests: '{0}/{1} 처리 전 요청사항',
	outOfAverageDaysOverdue: '{0}/{1} 처리 전 요청사항',
	draftRequests: '{0} 초안 요청사항',
	noResultMessageHeader: '표시할 데이터가 없습니다. 계속하려면 기업을 추가로 선택하십시오.',
	noResultMessageSubHeader: '',
	members: '멤버',
	memberLabel: '멤버',
	adminLabel: '관리자',
	projectOwnerLabel: '프로젝트 소유자',
	viewsLabel: '보기',
	metrics: '지표',
	yes: '예',
	no: '아니오',
	emptyMessageAvailableGroup: '그룹이 아직 생성되지 않았습니다. <br> 시작하려면 <b>그룹 추가</b>를 선택하십시오.',
	thereIsNoDataToDisplayForThisEntity: '이 기업에 표시할 데이터가 없습니다',
	typeLabel: '유형',
	groupsLabel: '그룹',
	group: '그룹',
	entitiesLabels: '기업',
	entityLabel: '기업',
	nameLabel: '이름',
	searchTeamMembers: '팀 멤버 검색',
	notSelectedLabel: '미선택',
	entitiesLabel: '기업',
	noDataAvailableLabel: '사용 가능한 데이터 없음',
	delete: '삭제',
	deleted: '삭제됨',
	addAMember: '멤버 추가',
	addMemberHeaderText: '프로젝트 그룹 하나 이상에 신규 멤버를 추가하십시오',
	teamMemberInformation: '팀 멤버 정보',
	teamMemberNote: '선택한 그룹에 추가하려는 내부 또는 외부 팀 멤버 이름이나 이메일을 입력하십시오',
	selectGroupNote: '그룹을 하나 이상 선택하십시오. 그룹 멤버는 그룹이 연결된 조직도 기업과 그 기업의 종속기업 모두에 대한 EY Canvas engagement 데이터를 볼 수 있습니다.',
	inviteAndClose: '초대 & 닫기',
	inviteAndAddAnother: '초대 & 더 추가',
	contacts: '연락처',
	email: '이메일',
	emailAll: '모두 이메일',
	contactTeam: '팀 연락',
	emptyMessage: '이 engagement에 사용 가능한 연락처가 없습니다',
	comingDue: '만료 도래',
	tomorrow: '내일',
	next3days: '다음 3일',
	next5days: '다음 5일',
	next10days: '다음 10일',
	next30days: '다음 30일',
	comingDueNext5days: '만료 도래 (다음 5일)',
	entityDetails: '기업 세부정보',
	requestsByEntity: '기업별 요청사항',
	basedOnTheSelectedCategory: '선택한 범주 기준',
	requestCount: '요청 개수',
	selectedDay: '선택된 요일',
	editMember: '멤버 편집',
	editMemberHeaderText: '선택한 팀 멤버가 접근할 수 있는 그룹을 편집하십시오',
	editaGroup: '그룹 편집',
	editAGroupHere: '여기에서 그룹을 편집하십시오',
	selectAnotherFrame: '데이터를 보려면 다른 기간을 선택하십시오',
	emptyFrameShort: '계속하려면 기업을 추가로 선택하십시오',
	emptyFrame: '계속하려면 추가 기업이나 다른 기간을 선택하십시오',
	editMemberHeaderText: '선택한 팀 멤버가 접근할 수 있는 그룹을 편집하십시오',
	confirm: '확인',
	markCompleteModalInstrTextPart1: '이 프로젝트를 완료하시겠습니까?',
	markCompleteModalInstrTextPart2: '이 작업을 하고 나면 실행 취소할 수 없습니다. 완료된 프로젝트는 신규 프로젝트를 생성할 때 roll forward하여 템플릿으로 사용할 수 있습니다.',
	firstPage: '첫 페이지',
	lastPage: '마지막 페이지',
	nextPage: '다음 페이지',
	prevPage: '이전 페이지',

	// Add Tag
	keyContacts: '주요 연락처',
	customTags: '사용자지정 태그',

	// Manage Tags
	manageTagInstructional: '여기에서 신규 사용자지정 태그를 생성하십시오. 기존 사용자지정 태그를 편집하거나 삭제할 수도 있습니다. 연락처에 태그하면 EY Canvas Oversight 프로젝트 내 연락처를 관리할 수 있습니다.',
	emptyCustomTagsList: '사용자지정 태그가 아직 생성되지 않았습니다',
	manageTagTitle: '사용자지정 태그 관리',
	manageTagLinkButton: '태그 관리',
	color: '색상',
	tagName: '이름',
	tagDelete: '삭제',
	tagCreate: '신규 태그 생성',
	customTagsHeader: '사용자지정 태그',

	//preparer assignment tile
	totalPreparerAssignments: '총 작성자 배정',
	inprogress: '진행 중',
	preparerAssignments: '작성자 배정',
	byAssignmentStatus: '배정 상태별',
	taskWithoutPreparerAssignments: 'task 작성자 배정 없음',
	tasksWithoutPreparerAssignments: 'task 작성자 배정 없음',
	preparerFilterTitle: '작성자',

	// reviewer assignment tile
	totalReviewerAssignments: '총 검토자 배정',
	taskWithoutReviewerAssignments: 'task 검토자 배정 없음',
	tasksWithoutReviewerAssignments: 'task 검토자 배정 없음',
	reviewerFilterTitle: '검토자',

	assignments: '배정',
	notes: '노트',
	preparerNotAssigned: '작성자 배정되지 않음',
	reviewerAssignments: '검토자 배정',
	reviewerNotAssigned: '검토자 배정되지 않음',
	basedOnPreparerAssignments: '작성자 배정에 따름',
	basedOnPreparerAssignmentsOpenAndInProgress: '처리 전 및 진행 중 상태인 작성자 배정에 따름',
	basedOnReviewerAssignments: '검토자 배정에 따름',
	basedOnReviewerAssignmentsOpenAndInProgress: '처리 전 및 진행 중 상태인 검토자 배정에 따름',

	statusOpen: '상태 - 처리 전',
	statusInProgress: '상태 - 진행 중',
	statusClosed: '상태 - 닫힘',
	byPriorityLow: '우선순위 기준 - Low',
	byPriotityMedium: '우선순위 기준 - Medium',
	byPriorityHigh: '우선순위 기준 - High',
	byPriorityCritical: '우선순위 기준 - Critical',

	findingsLabel: '발견사항',
	riskLabel: '위험',
	digitalAuditLabel: '디지털 감사',
	digitalAuditStrategy: '디지털 감사전략',
	byDigitalAuditTypeLabel: '디지털 감사전략별',
	basedOnProfileSelection: '프로필 선택 기준',
	basedOnSelectionArchiveForm: 'Archive 양식 선택 기준',
	MisstatementsByType: '유형별 왜곡표시',
	DeficienciesBySeverity: '심각성별 미비점',
	MisstatementsLabel: '왜곡표시',
	DeficienciesLabel: '미비점',
	primarTeamDeficiencyHeader: 'Primary team - {0}',
	componentRegionalTeamDeficiencyHeader: '지역 및 부문 팀 - {0}',
	auditTileHeaderTextPrimary: 'Primary team - {0}',
	componentRegionalTeamHeader: '지역 및 부문 팀 - {0}',
	allTeamDeficiencyHeader: '모든 engagement - {0}',
	primarTeamMisstatementHeader: 'Primary team - {0}',
	componentRegionalTeamMisstatementHeader: '지역 및 부문 팀 - {0}',
	allTeamMisstatementHeader: '모든 engagement - {0}',
	deficiencyLabel: '미비점',
	inherenRisktLabel: '중요왜곡표시위험',
	significantRiskLabel: '유의적',
	fraudRiskLabel: '부정',
	significantDeficiencyLabel: '유의한 미비점',
	materialWeaknessLabel: '중요한 취약점',
	factualLabel: '사실적',
	projectedLabel: '투영된',
	judgmentalLabel: '판단적',
	reclassificationLabel: '재분류',
	totalDeficiencyLabel: '총 미비점',
	totalRiskLabel: '총 위험',
	totalRisksLabel: '총 위험',
	totalDeficienciesLabel: '총 미비점',
	totalMisstatementLabel: '총 왜곡표시',
	totalMisstatementsLabel: '총 왜곡표시',
	allEngagementHeader: '모든 engagement - {0}',
	noAuditSightGroupData: '<b>표시할 그룹감사 데이터 없음.</b> <br> 요약 데이터를 보려면 토글에서 <b>모두</b>를 선택하십시오.',
	noAuditTileDataPlaceholder: '표시할 데이터가 없습니다. 계속하려면 기업을 추가로 선택하십시오.',
	openReviewNotes: '처리 전 리뷰노트',
	byPriorityLevel: '우선순위별',
	risks: '위험',
	groupRoleLabel: '그룹 역할',
	totalRisks: '총 위험',
	byType: '유형별',
	inherent: '중요왜곡표시위험',
	significant: '유의적',
	fraud: '부정',
	strategy: '전략',
	notApplicable: '해당 없음',
	customizableTable: '표 수정',
	selectUpToOptionHeader: '최대 {0}개 옵션 선택',
	selectUpToThreeOptionHeader: '최대 3개의 옵션 선택',
	selectUpToFourOptionHeader: '최대 4가지 옵션 선택',
	psps: 'PSP',
	osps: 'OSP',
	hxpsps: 'HxPSP',
	totalSubstantiveProcedures: '총 실증절차',
	totalSubstantiveProcedure: '총 실증절차',
	totalITControls: '총 ITGC 및 ITSP',
	totalITControl: '총 ITGC 및 ITSP',
	testing: '테스트',
	nonTesting: '테스트하지 않음',
	auditStrategy: '감사전략',
	totalControls: '총 통제',
	totalControl: '총 통재',
	removeProject: '프로젝트 제거',
	removeProjectInstructionalText: '활성 프로젝트 목록에서 다음 프로젝트를 제거하시겠습니까? <br>프로젝트를 제거하면 더 이상 접근할 수 없습니다.',
	substantiveProcedures: '실증',
	controls: '통제',
	itlabel: 'IT',

	//delegates removed
	userDelTitle: '내 대리인',
	delTitleDetail: '여기에 열거된 팀 멤버에게 접근 권한을 위임했습니다. 귀하의 대리인은 귀하에게 접근 권한이 있는 모든 고객에 접근 권한이 있습니다.',
	delElseMsg: '아직 대리인을 추가하지 않았습니다',
	delegateTitle: '대리인 제거',
	delegateMember: '위임됨',
	deleteMessage: '이 대리인을 제거하시겠습니까?<br/> 제거하고 나면, 더 이상 귀하를 대신해서 프로젝트를 생성할 수 없습니다.',

	//Advanced filters.
	advancedFilters: '고급 필터',
	selectAll: '모두 선택',
	deselectAll: '모두 선택 해제',
	applyFilters: '필터 적용',
	region: 'Region',
	country: 'Country',
	city: 'City',
	state: 'State',
	advancedFiltersInstructionalText: 'Engagement 데이터를 보려는 기업을 선택하십시오',
	advancedFiltersInstructionalTextLine2: '접근 권한이 없는 기업은 비활성화된 것으로 나타납니다. 접근 권한이 필요하면 그룹 관리자와 얘기하십시오.',
	engagementsSelected: 'engagement 선택됨',
	filterYes: '예',
	filterNo: '아니오',

	//Group Audit
	pendingResponse: '응답 보류 중',
	primaryTileTitle: 'Primary team 상태',
	reportingFormStatus: '보고 양식 상태',
	reportingForm: '보고 양식',
	summarizedForPrimaryTeams: 'Primary 팀을 위한 요약',
	primaryTileSubtitle: '그룹 보고 양식 전송됨',
	received: '수신됨',
	dueToPrimaryTeam: 'Due to primary team',
	sentToPrimaryTeam: 'Primary team에 전송됨',
	evidencePending: '증거 보류 중',
	evidenceComplete: '증거 완료',
	componentTileTitle: '부문 팀 상태',
	componentTaskStatus: '부문 task 상태',
	componentTask: '부문 task',
	comingsoonTaskStatus: '곧 제공',
	summarizedForComponentTeams: '부문 팀을 위한 요약',
	componentTileSubtitle: '그룹 감사 task 수신됨',
	unlinkedTask: '링크 해제된 task',
	unlinkedTasks: '링크 해제된 task',

	//Group Risk Assessment
	groupRiskAssessmentTitle: '위험',
	groupRiskSummaryTitle: '그룹 위험 평가',

	// Reporting
	reportModifications: '보고서 변형',
	byReportType: '보고서 유형별',
	notSelected: '미선택',
	unmodified: '변형되지 않음',
	modified: '변형됨',
	reports: '보고서',
	opinions: '의견',
	modifiedReports: '변형된 보고서',
	modifiedOpinions: '변형된 의견',
	adverse: '부적정',
	disclaimer: '의견거절',
	qualification: '한정',
	qualified: '한정',
	engagementReportTooltip: '보고서일이 오늘 이전인 engagement만 여기에 요약됐습니다. 아래 표에 모든 engagement가 표시되어 있습니다.',
	geography: 'Geography',
	standars: '기준',
	gaap: 'GAAP',
	gaapUs: 'GAAP US',
	ifrs: 'IFRS',
	other: 'Other',
	yearEndDate: '회계연도말일',
	endDateOfPeriodCovered: '보고기간말일',
	reportDate: '보고서일',
	archiveDeadline: 'Archive 기일',
	reportType: '보고서 유형',
	opinionType: '의견 유형',
	taskStatus: 'Task 상태',
	exportData: '데이터 내보내기',
	exportToExcel: '내보내기',
	orgChartEntity: '조직도 기업',
	engagementId: 'Engagement ID',
	contactName: '연락처 이름',
	contactEmail: '연락처 이메일',
	statusInherent: 'By Type - Risk of material misstatement',
	statusSignificant: '유형별 - 유의적',
	statusFraud: '유형별 - 부정',
	substantivePSPs: '실증 - PSP',
	substantiveOSPs: '실증 - OSP',
	substantiveHxPSPs: '실증 - HxPSP',
	controlsTesting: '통제 - 테스트',
	controlsNonTesting: '통제 - 비테스트',
	iTTesting: 'IT - 테스트',
	iTNonTesting: 'IT - 비테스트',
	misstatementsFactual: '왜곡표시 - 사실적',
	misstatementsProjected: '왜곡표시 - 투영된',
	misstatementsJudgmental: '왜곡표시 - 판단적',
	misstatementsReclassification: '왜곡표시 - 재분류',
	deficienciesDeficiency: '미비점 - 미비점',
	deficienciesSignificantdeficiency: '미비점 - 유의한 미비점',
	deficienciesMaterialweakness: '미비점 - 중요한 취약점',
	statusComplete: '상태 - 완료',
	statusInReview: '상태 - 리뷰 중',
	statusInProgress: '상태 - 진행 중',
	statusOpen: '상태 - 처리 전',
	statusNotSent: '상태 - 미전송',
	statusReturned: '상태 - 반송됨',
	statusDocumentationPending: '상태 - 문서화 보류 중',
	statusDocumentationComplete: '상태 - 문서화 완료',
	statusReceivedbyEY: '상태 - EY가 수신함',
	statusAcceptedbyEY: '상태 - EY가 수락함',
	statusOutstanding: '상태 - 처리 전',
	noCompletedProjectsMessagePart1: '완료 프로젝트가 없습니다',
	noCompletedProjectsMessagePart2: '프로젝트 소유자라면 프로젝트에 완료 표시할 수 있습니다. 신규 프로젝트를 생성할 때 완료 프로젝트를 roll-forward하여 템플릿으로 사용할 수 있습니다.',
	noCompletedProjectsMessage: '완료된 프로젝트가 없습니다. <br>귀하가 프로젝트 소유자라면, 프로젝트에 완료 표시할 수 있습니다. 완료된 프로젝트는 신규 프로젝트를 생성할 때 roll forward하여 템플릿으로 사용할 수 있습니다.',
	requests: '요청사항',

	//Reporting readiness report
	week: '주',
	weeks: '주',
	readinessReportTitle: '보고서 준비',
	taskCompletionByEngagement: 'Engagement별 task 완료',
	readinessLegendTitle: '보고서일까지 근접성',
	basedOnReportDateProximityForEachEngagement: '각 engagement별 보고서일 근접 기준',

	//ReportCompletion
	taskCompletionStatus: 'Task 완료 상태',
	taskCompletionByLocation: '위치별 task 완료',
	basedOnCompletedTasksForEachEngagement: '각 engagement별 완료 task 기준',
	byGeography: 'Geography별',
	taskCompletion: 'Task 완료',
	completedTasks: '완료 task',

	engagementArchived: '이 engagement는 archive됐습니다. 데이터를 더 이상 사용할 수 없습니다.',
	externalUsersNoActiveProjMessage: '활성 프로젝트가 없습니다. 접근 권한을 얻으려면 EY 팀 멤버와 얘기하십시오.',

	//Error Messages
	networkErrorMessage: '응용프로그램 네트워크에 오류가 발생했습니다. 페이지를 새로 고침하고 나중에 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	genericErrorMessage: '선택한 작업은 지금 완료할 수 없습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	otherProjectPlaceholder: '귀하의 EY Canvas engagement가 여기에 열거된 EY Canvas Oversight 프로젝트에 연결됐습니다. 귀하는 이 프로젝트에 접근권한이 없습니다. 접근권한을 얻으려면 프로젝트 소유자 또는 그룹 관리자와 얘기하십시오.',
	noProjectsAvailable: '사용 가능한 프로젝트 없음',
	completedProjectPlaceholder: '완료된 EY Canvas Oversight 프로젝트가 여기에 열거됩니다. 신규 프로젝트를 생성할 때 완료된 프로젝트를 템플릿으로 사용하려면 <b> Roll forward </b> 옵션을 선택하십시오.',
	completedNotProjectPlaceholder: '완료된 프로젝트가 없습니다. <br>귀하가 프로젝트 소유자라면, 프로젝트에 완료 표시할 수 있습니다. 완료된 프로젝트는 신규 프로젝트를 생성할 때 roll forward하여 템플릿으로 사용할 수 있습니다.',

	//Log out and time out modal
	logoutModalTitle: '보호를 위한 자동 로그아웃',
	sessionTimerMsgLine1: '활동이 없기 때문에 현재 작업 세션이 곧 만료됩니다.',
	sessionTimerMsgLine2: '보안을 위해, 30분 동안 활동이 없으면 EY Canvas Oversight 세션이 자동으로 종료됩니다.',
	sessionTimerMsgLine3: '현재 세션은 {0}분 후에 만료됩니다.',
	sessionTimerMsgLine4: '로그인 상태를 유지하려면',
	modalContinueButton: '<b>계속</b>을 클릭하십시오',
	modalLogoutButton: '로그아웃',
	modalCloseButton: '닫기',
	countryNotAvailable: '국가를 사용할 수 없습니다',
	regionNotAvailable: 'Region 사용 불가능',
	notAvailable: '사용 불가능',
	signout: '로그아웃',
	engagementTypeNotAvailable: 'Engagement 유형 사용 불가능',

	// Admin portal
	administration: '관리',
	mainPageInstructionalText: 'EY Canvas Oversight Administrative Portal에 오신 것을 환영합니다',
	manageProjectsFormatted: '<br />프로젝트 관리',
	manageUsersFomatted: '<br />사용자 관리',
	manageAdminsFormatted: '<br />Oversight admins 관리',
	homeLabel: '홈',
	userNotFoundError: '사용자를 찾을 수 없습니다',
	manageUsersInstructionalText: 'GUI를 입력하여 사용자 검색',
	selectRole: '역할 선택',
	role: '역할',

	//Manage User
	manageUsersTitle: '사용자 관리',
	otherProjectsTabTitle: '다른 프로젝트',
	validGuiErrorMsg: '유효한 GUI 입력',
	accessibleProjects: '접근 가능한 프로젝트',
	delegates: '대리인',
	projectID: '프로젝트 ID',
	projectStatus: '프로젝트 상태',
	gui: 'GUI',
	emailAddress: '이메일 주소',
	userRole: '사용자 역할',
	userID: '사용자 ID',
	noResultMessage: '검색 기준과 일치하는 결과가 없습니다',
	noResultFound: '기록을 찾을 수 없습니다',
	userDetails: '사용자 세부정보',
	active: '활동',
	inActive: '비활동',
	manageAdmins: 'EY Canvas Oversight 관리자 관리',
	manageAdminsInstructionalText: '모든 EY Canvas Oversight 관리자가 아래 열거되어 있습니다. 관리자의 역할을 편집하거나 관리자를 추가하고 제거할 수 있습니다.',
	adminReader: 'Application 관리 판독자',
	adminWriter: 'Application 관리 작성자',
	superAdmin: 'Application 수퍼 관리자',
	revertChanges: '변경사항 환원',
	unSavedChanges: '저장되지 않은 변경사항',
	unSavedChangesMessage: '계속하면 저장되지 않은 변경사항이 지워집니다. <br/>계속하려면 <b>확인</b>을 선택하십시오. 원래 페이지로 돌아가서 변경사항을 저장하려면 <b>취소</b>를 선택하십시오.',
	addNewAdmin: '신규 관리자 추가',
	addEYContactInstructions: '이름 또는 이메일 주소를 입력하고 엔터키를 눌러 결과를 확인하십시오. 신규 Oversight 관리자를 추가하려면 역할을 선택하십시오.',

	// ManageProjects
	orgChartEntities: '조직도 엔터티',
	manageProjectsInstructionalText: '프로젝트 ID를 입력하여 프로젝트 검색',
	projectDetails: '프로젝트 세부정보',
	parentEntity: 'Parent 엔터티',
	connectedGroups: '연결된 그룹',
	validProjectIDError: '유효한 프로젝트 ID 입력',
	addNewMember: '멤버 추가',
	adminAddMemberInstructionalText: '사용자를 검색하고 그들이 추가되어야 하는 그룹을 선택하십시오',
	currentApplication: 'Current application',

	//Software Update
	softwareUpdate: '소프트웨어 업데이트',
	updateNow: '지금 업데이트',
	updateMsg: 'EY Canvas Oversight 소프트웨어를 지금 업데이트할 수 있습니다. 업데이트를 다운로드하여 설치하려면 지금 업데이트를 선택하십시오. 페이지가 새로 고쳐집니다.',

	//ContactDB
	placeholderForSearch: '검색',
	contactClearAll: '모두 처리',
	contactShowMoreFilters: 'more',
	contactListFilter: '연락처 목록에 접근',
	dashboardAccessFilter: '대시보드에 접근',
	groupRoleFilter: '그룹 역할',
	tagFilter: '태그',
	countryFilter: '국가',
	serviceLineFilter: '서비스라인',
	typeFilter: '유형',
	roleFilter: '역할',
	dashboardAccess: '대시보드 접근권한',
	contactList: '연락처 목록',
	noEntitiesMessage1: '표시할 데이터가 없습니다',
	noEntitiesMessage2: '계속하려면 기업을 추가로 선택하십시오',
	noContacts: '이 기업의 연락처가 없습니다',
	engagementsContacts: 'Engagement',
	manuallyAdded: '수동으로 추가됨',
	dashboardViews: '보기',
	columnName: '이름',
	columnEmail: '이메일',
	columnEngagement: 'Engagement',
	columnType: '유형',
	columnRole: '역할',
	columnServiceLine: '서비스라인',
	columnDashboard: '대시보드에 접근',
	columnDashboardView: '대시보드 화면',
	columnContactList: '연락처 목록에 접근',
	columnTags: '태그',
	columnEntity: '기업',
	noResults: '결과를 찾을 수 없습니다',
	noResultsAvailable: '사용 가능한 데이터가 없습니다',
	searchContacts: '연락처 검색',
	selectedContacts: '선택된 연락처',
	tag: '태그',
	manageAccess: '접근 관리',
	formLengthMessage: '텍스트는 {number}자를 초과할 수 없습니다',
	viewMoreColumns: '열 더 보기',
	projectOwnerBadge: '프로젝트 소유자',
	entityAdminBadge: '기업 관리자',
	eyTeam: 'EY팀',
	clientTeam: '고객 팀',
	userProfile: '사용자 프로필',
	columnGroupRiskAssessment: '그룹 위험평가 접근',
	externalUserDenyMessage: 'External users cannot be granted access to the Group risk assessment module.',
	//ContactDB - Toolbar
	toolbarAddContact: '연락처 추가',
	toolbarAccessLog: '접근 로그',
	toolbarMessageLog: '메시지 로그',
	toolbarCustomizeTable: '표 수정',
	toolbarExportData: '데이터 내보내기',
	toolbarManageAccess: '접근 관리',
	toolbarDefineAttributes: '속성 정의',
	toolbarGenerateMessage: '메시지 생성',
	toolbarTags: '태그',
	toolbarRemove: '제거',

	//ContactDB - Add Contact Modal
	addContactLabel: '연락처 추가',
	addContactTitle: '연락처 추가',
	addContactInstructional: '귀하의 EY Canvas Oversight 프로젝트에 연락처를 하나 이상 추가하십시오. 귀하가 추가한 연락처에 대시보드 또는 연락처 목록에 대한 접근권한이 필요하면 여기에서 접근을 부여할 수 있습니다.',
	columnEntities: '기업',
	noEntities: '없음',
	duplicatedUser: '은(는) 이미 연락처에 추가됐습니다. 귀하는 연락처 목록에서 그들의 접근권한을 관리할 수 있습니다.',
	accessToDashboard: '대시보드에 접근',
	dashBoardsViews: '대시보드 접근 및 보기',
	placeholderEntities: '기업',
	placeholderAccess: '접근권한',
	placeholderAttributes: '정보',
	placeholderTags: '태그',
	projectOwnerAccessLabel: '프로젝트 소유자 접근권한',
	entityAdminAccessLabel: '기업 관리자 접근권한',
	accessToContactListLabel: '연락처 목록에 접근',
	saveContactLabel: '저장',
	cancelContactLabel: '취소',
	noContactsAdded: '연락처가 아직 추가되지 않았습니다',
	noCustomColumns: '귀하의 프로젝트에 사용자지정 열이 생성되지 않았습니다',
	toggleContactYes: '예',
	toggleContactNo: '아니오',
	mustSelectOneEntity: '계속하려면 기업을 하나 이상 선택해야 합니다',
	mustSelectOneView: 'EY Canvas Oversight 대시보드에 접근을 부여하고 있는 모든 연락처에 대해 보기를 하나 이상 선택하십시오',
	mustBeOnwerOrAdministrator: '이 작업을 하려면 프로젝트 소유자 또는 기업 관리자여야 합니다. 계속하려면 선택한 기업을 업데이트 하십시오.',
	cannotEditAccessForProjectOwners: '귀하는 프로젝트 소유자에 대한 접근권한을 편집할 수 없습니다: {list}',
	attributesLabel: '정보',
	externalUserDomainMismatch: '선택한 하나 이상의 기업에 도메인이 허용되지 않습니다. 기업 설정 흐름에 필수 도메인을 추가하여 다시 시도하십시오.',
	projectOwnerAccessToogleInfo: '프로젝트 소유자는 EY Oversight 프로젝트에 대한 모든 권한을 가지고 있습니다',
	entityAdminAccessToogleInfo: '기업 관리자는 필요에 따라 관리 작업을 수행하기 위한 기업 특정 권한을 가지고 있습니다',

	//ContactDB-CustomizeTable Modal
	customizeTableModal: '표 수정',
	InstructionalTextCustomizeTableModal: 'Select the columns you would like to view.',
	cancelCustomizeTable: '취소',
	saveCustomizeTable: '저장',
	tooltipCustomizeTable: '표 수정',
	standardColumns: '표준 열',
	customColumns: '사용자지정 열',
	closeTitleModal: '닫기',
	addCustomColumn: '사용자지정 열 추가',
	editCustomColum: '사용자지정 열 편집',
	addCustomColumnLegend: '사용자지정 열에서 귀하의 연락처에 대한 추가 정보를 저장하고 관리할 수 있습니다. 귀하의 프로젝트에 사용자지정 열을 5개까지 생성할 수 있습니다. 열 생성 후, 하나 이상의 연락처를 선택하고 정보를 정의할 수 있습니다. 사용자지정 열을 제거하면 연락처 정보도 제거됩니다.',
	deleteCustomColumnLegend: '사용자지정 열을 삭제하려면, <b>삭제</b> 아이콘을 선택하십시오. 계속하면  프로젝트를 더 이상 사용할 수 없습니다. 귀하가 이전에 연락처에 적용한 정보도 삭제됩니다.',
	customColumnName: '열 이름',
	attribute: '정보',
	attributes1to5: '정보 (1-5)',
	visibleToExternal: '외부 연락처에게 보임',
	noCustomColumnMsg: 'No custom column added',

	//ContactDB - Add Contact Modal
	filterTooltip: '필터',
	searchTitletip: '검색',
	addExternalContactColumnName: '이름',
	addExternalContactColumnDomain: '도메인',
	confirmDomain: '도메인 확인',

	//ContactDB - Profile Modal
	profileModalTitle: '프로필',
	profileModalAccessSection: '접근',
	profileModalCustomAttributesSection: '사용자지정 정보',
	profileModalDashboardSection: '대시보드 보기',

	//ContactDB - Generate Message
	selectMessageRecipients: '메시지 수신자 선택',
	notification: '알림',
	generateMessage: '메시지 생성',
	gmInstructionalText: "귀하가 선택한 연락처로 이메일 또는 알림을 전송하십시오. 알림은 내부 연락처로만 전송할 수 있습니다. 이메일은 내부 및 외부연락처로 전송할 수 있습니다.",
	messageType: '메시지 유형',
	messageRecipient: '메시지 수신자',
	selectContactsNow: '지금 연락처 선택',
	useSelectedContacts: '선택된 연락처 사용',
	moreFilters: '+  추가 필터',
	countries: '국가',
	groupRoles: '그룹 역할',
	groupRole: '그룹 역할',
	roles: '역할',
	role: '역할',
	serviceLines: '서비스라인',
	serviceLine: '서비스라인',
	contatcs: '연락처',
	singularContact: '연락처',
	singularEngagement: 'Engagement',
	allContact: '모든 연락처',
	allEntitles: '모든 기업',
	allCountries: '모든 국가',
	allGroupRoles: '모든 그룹 역할',
	allEngagements: '모든 engagement',
	allServicesLines: '모든 서비스라인',
	allRoles: '모든 역할',
	subject: 'Subject',
	removeTooltip: '제거',
	fromEntity: '기업에서',
	fromEngagement: 'Engagement에서',
	notificationMessage: '알림 메시지',
	linkLabel: '링크 레이블 (선택 사항)',
	link: '링크 (선택 사항)',
	fromEntityNotification: '기업에서',
	mustSelectOne: '계속하려면 연락처를 하나 이상 선택해야 합니다',
	emailSentMsg: '선택한 연락처로 이메일 메시지가 생성됐습니다',
	notificationSentMsg: '선택한 연락처로 알림이 전송됐습니다',
	messageFrom: '메시지 발신자',
	duplicateMessage: '중복 메시지',
	someEntities: '{0} entities selected',

	//ContactDB - Message Log
	messageLogInstruction: '귀하의 기업별로 전송된 메시지 목록을 검토하십시오. 후속 메시지를 보내야 하는 경우 이전 메시지를 복제할 수 있습니다.',
	messageLogTitle: '메시지 로그',
	today: '오늘',
	yesterday: '어제',
	thisWeek: '이번 주',
	lastWeek: '지난 주',
	twoWeeksAgo: '2주 전',
	older: '이전',
	notificationTo: '알림 수신자',
	emailTo: '이메일 수신자',
	sentBy: '전송자',
	from: 'From',
	date: '날짜',
	time: '시간',
	subject: 'Subject',
	multiContatcsLowerCase: '연락처',
	singleContactLowerCase: '연락처',
	seeMore: '더 보기',
	seeLess: '덜 보기',
	messageLogEmptyMessage: '전송된 메시지가 없습니다',
	messageLogFileExported: '메시지 로그',
	typeColumnToExportToExcel: '유형',
	sentByColumnToExportToExcel: '전송자',
	fromColumnToExportToExcel: 'From',
	dateColumnToExportToExcel: '날짜',
	timeColumnToExportToExcel: '시간',
	subjectColumnToExportToExcel: 'Subject',
	contactsColumnToExportToExcel: '연락처',
	emailExportToExcel: '이메일',
	notificationExportToExcel: '알림',

	//ContactDB - Access Log
	accessLog: '접근 로그',
	accessLogInstructional: '아래 표시된 팀 멤버를 검토하여 연락처에 추가하거나 제거할 지 결정하십시오',
	addAll: '모두 추가',
	removeAll: '모두 제거',
	ignoreAll: '모두 무시',
	contactsToAddEmpty: '지금 추가할 연락처가 없습니다',
	contactsToRemoveEmpty: '지금 제거할 연락처가 없습니다',
	ignore: '무시',
	addAllConfirmationModal: '하나 이상의 사용자에게 기업이 허용하지 않는 도메인이 있습니다. 사용자를 연락처 목록에 추가하려면 계속을 클릭하십시오. 도메인을 불러와 기업에 허용되는 도메인 목록에 추가합니다.',
	addConfirmationModal: '사용자에게 기업이 허용하지 않는 도메인이 있습니다. 사용자를 연락처 목록에 추가하려면 계속을 클릭하십시오. 도메인을 불러와 기업에 허용되는 도메인 목록에 추가합니다.',

	// ContactDB - Message Log - Filter
	messageTypeFilter: '메시지 유형',
	sentByFilter: '전송자',
	fromEntityFilter: '기업 발신',
	toEntityFilter: '기업 수신',
	toCountryFilter: '국가 수신',
	toGroupRoleFilter: '그룹 역할 수신',
	toEngagementFilter: 'Engagement 수신',
	toServiceLineFilter: '서비스라인 수신',
	toRoleFilter: '역할 수신',

	//ContactDB - Define Attributes
	defineAttributes: '속성 정의',

	// ContactDB Edit Entity Modal
	// Step 2 - Edit Entity Modal
	addAnotherEntityAdministrator: '다른 기업 관리차 추가',
	editEntity: '기업 편집',
	entityAdministrators: '기업 관리자 (선택사항)',
	editEntityAdministratorsInstruction: '기업 관리자를 하나 이상 추가할 수 있습니다. 관리자는 이 기업에 연락처를 추가하고 EY Canvas Oversight 모듈에 접근권한을 부여할 수 있습니다.',
	editEntityDomainInstruction: '외부 팀 멤버가 EY Canvas Oversight에 접근하려면 이 기업에 유효한 도메인이 있어야 합니다. 시스템은 설정 마법사 4단계에서 연결된 EY Canvas engagement로부터 승인된 도메인을 불러옵니다. 이 기업에 다른 외부 팀 멤버를 초대하려면 도메인을 하나 이상 추가하십시오. 도메인은 이메일 주소에서 @ 기호 뒤에 있는 문자입니다.',
	level: '수준 {0}',

	// ContactDB Remove Contacts
	removeIcon: '제거',
	removeContactTitle: 'Remove contacts',
	removeInstructionalText: '귀하의 프로젝트에서 이 연락처를 제거하시겠습니까? 이 연락처가 여러 기업에 속한 경우, 모든 기업에서 제거됩니다. 연락처를 단일 기업에서 제거하려면 대신 접근 편집을 선택하십시오.',
	removeSelectedContacts: '선택한 연락처',

	domainNotPermitted: '이 기업에는 한 명 이상의 기업 관리자를 위한 도메인이 허용되지 않습니다',
	listView: '목록 보기',
	cardView: '카드 보기',

	recordsNotAvailable: '기록 사용 불가능',

	// Project Layout Update
	welcomeLabel: '환영합니다',
	activeProjectsInstructionalText: '여기에 열거된 EY Canvas Oversight 프로젝트에 접근할 수 있습니다. 모듈을 선택하여 이동하거나 개수를 클릭하여 각 프로젝트 세부정보를 확인하십시오.',
	otherProjectsInstructionalText: '귀하의 EY Canvas engagement는 여기에 열거된 EY Canvas Oversight 프로젝트에 연결되어 있습니다. 귀하는 이 프로젝트에 접근권한이 없습니다.  접근권한을 얻으려면 프로젝트 소유자 또는 기업 관리자와 얘기하십시오.',
	completedProjectsInstructionalText: '귀하의 완료 EY Canvas Oversight 프로젝트가 여기에 열거되어 있습니다. 신규 프로젝트 생성 시 완료 프로젝트를 템플릿으로 사용하려면 <b>Roll Forward</b> 옵션을 선택하십시오.',
	goToLabel: '이동',
	entityAdmins: '기업 관리자',
	entityAdmin: '기업 관리자',
	keyContacts: '주요 연락처',
	keyContact: '주요 연락처',
	contactListLabel: '연락처 목록',
	draftlabel: '초안',
	projectWizard: '프로젝트 마법사',
	noEntityAdminsAdded: '기업 관리자가 연결되지 않음',
	addProjectOwner: '프로젝트 소유자 추가',
	addProjectOwnerInstrText: '사용자를 이름이나 이메일로 검색하여 선택한 프로젝트의 프로젝트 소유자로 추가하십시오',
	projectSummary: '프로젝트 요약',
	privacyNotice: '개인정보보호 고지',
	groupOversightProject: '그룹 Oversight 프로젝트 (신규!)',
	groupOversightProjectTooltip: '<b>그룹 Oversight 프로젝트</b>에서 EY Oversight 프로젝트를 생성한 귀하의 Primary 및/또는 지역 EY Canvas engagement를 식별할 수 있습니다. 귀하의 EY Canvas 그룹 구조에서 식별된 지역 및/또는 부문 EY Canvas engagement는 <b>자동으로</b> EY Oversight 프로젝트 설정의 일부로 채워집니다. <br><br> 또한, 이러한 프로젝트 유형에는 Primary, 지역 및/또는 부문 engagement에 대한 위험 평가 활동을 볼 수 있는 그룹 위험평가 모듈에 대한 접근 권한이 있습니다.',
	oversightProject: 'Oversight 프로젝트 (법정 감사)',
	oversightProjectTooltip: 'Oversight 프로젝트 (법정 감사)에서 귀하의 고객을 수동으로 선택하고 나서 EY Oversight 프로젝트를 생성할 연결된 EY Canvas engagement를 선택할 수 있습니다',

	// Group Risk Assessment
	noGroupRiskAssessmentForSelection: '이 EY Oversight 프로젝트에 대한 그룹 위험평가 활동이 없습니다',
	engagementData: 'Engagement 데이터',
	engagementDetails: 'Engagement 세부정보',
	reconciliations: '조정',
	nextComponent: '다음 부문',
	prevComponent: '이전 부문',
	allAccounts: '모든 계정',
	generateEmail: '이메일 생성',
	reconciliationDetailInstructional: 'The information below summarizes the total number of Primary Team accounts, and risks of material misstatement, which were related to the component in the Primary Team\'s EY Canvas engagement and included in the group risk assessment communications. Select a Primary Team account/risk to relate it to the equivalent account/risk in the component team\'s EY Canvas engagement.',
	primaryTeamAccountName: 'Primary Team account name',
	componentTeamAccountName: '부문 팀 계정 이름',
	designation: '지정',
	openAccounts: '처리 전 계정',
	componentTeamAccounts: '부문 팀 계정',
	componentTeamAccountsAndPsp: 'Component team accounts and related PSP Index(es)',
	mapAccountsMessage: 'Each Primary Team account should have at least one related component team account. {button} to get started.',
	primaryTeamAccountStatus: 'Primary Team account status',
	totalAccounts: '총 계정',
	assessedAccounts: '평가된 계정',
	primaryTeamRiskStatus: 'Primary Team risk status',
	openRisks: '처리 전 위험',
	assessedRisks: '평가된 위험',
	totalRisks: '총 위험',
	primaryTeamRiskDesignationAndName: 'Primary Team risk designation and name',
	primaryTeamAccountsRelatedToRisk: '위험에 연결된 Primary 팀 계정',
	componentTeamRisksAndRelatedAccounts: '부문 팀 위험 및 연결된 계정',
	relateRisks: '위험 연결',
	relateRisksMessage: 'Each Primary Team risk should have at least one related component team risk. {button} to get started.',
	pspIndexesHeader: 'PSP',
	pspIndexes: 'PSP Index',
	markAssessed: '평가됨 표시',
	markReOpen: '다시 열기',
	riskMarkAssessedMessage: 'View related component team risks to assess whether risk designations, accounts and relevant assertions match the Primary Team risks and accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	riskWasPreviousAssessedMessage: "Status changed from Assessed to Open due to changes in the related risk, risk designation, account or assertions. Re-assess the risk grouping. When complete, {button}.",
	riskMarkOpenMessage: 'If changes need to be made to a risk grouping that has already been marked assessed, {button} the risk grouping. This risk grouping will appear in the Open risks view.',
	markAssessedSuccessMessage: 'The account grouping has successfully been marked assessed. To review, click \'Assessed accounts\' in the account status tile.',
	reopenAssessedAccount: '다시 열기',
	reopenAssessedAccountMessage: 'If changes need to be made to an account grouping that has already been marked assessed, {button} the account grouping. This account grouping will appear in the Open accounts view.',
	reopenSuccessMessage: 'The account grouping has successfully been re-opened. To view, click \'Open accounts\' in the account status tile.',
	teamAccountMappedMessage: 'View related component team accounts to assess whether account designations, relevant assertions and inherent risk assessments match the Primary Team accounts included in the Primary Team group risk assessment communication. When complete, {button}.',
	teamAccountWasPreviousAssessedMessage: 'Status changed from Assessed to Open due to changes in the related account, account designation or inherent risk assessment. Re-assess the account grouping. When complete, {button}.',
	createComment: 'Comment 생성',
	editComment: 'Comment 편집',
	commentTitle: 'Comment',
	createCommentInstructionalText: "선택한 계정 또는 위험에 대한 comment 세부정보를 입력하고 ’저장’을 선택하여 마치십시오",
	editCommentInstructionalText: "선택한 계정 또는 위험에 대한 comment 세부정보를 편집하고 ’저장’을 선택하여 마치십시오",
	lastModified: '최근 수정',
	addComment: 'Comment 추가',
	accountDescription: '부문 팀 계정에 연결되지 않고 평가됨 표시된 Primary 팀 계정을 보려면 처리 전 계정을 선택하십시오. 평가된 Primary 팀 계정을 보려면 평가된 계정을 선택하십시오.',
	riskDescription: '부문 팀 위험에 연결되지 않고 평가된 것으로 표시된 Primary team 위험을 보려면 처리 전 위험을 선택하십시오. 평가된 Primary team 위험을 보려면 평가된 위험을 선택하십시오.',
	successAssessedMessage: 'The risk grouping has successfully been marked assessed. To review, click \'Assessed risks\' in the risk status tile.',
	successReOpenMessage: 'The risk grouping has successfully been re-opened. To view, click \'Open risks\' in the risk status tile.',

	// Relate risks modal
	relateRisksModalTitle: 'Relate component team risks',
	relateRisksModalInstructionalText: 'Select risk(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team risk.',
	primaryRegionTeamRisk: 'Primary Team risk:',
	primaryTeamRiskLabel: 'Primary team 위험',
	thereIsNoDataToDisplayForThisSelection: '이 선택사항에 표시할 데이터가 없습니다',
	accountAndAsssociated: 'Account(s) and associated PSP index(es)',
	noAccountOrPspAssociated: 'There is not account or associated PSP index.',
	disabledRegionComponentTeamRiskLabel: "이 부문 팀 위험은 이미 다른 Primary team 위험에 매핑됐습니다. 부문 팀 위험은 하나의 Primary team 위험에만 매핑될 수 있습니다. 해당하는 경우, 이 위험을 연결 해제하려면 관련 Primary 위험에 대해 ‘위험 연결’을 선택하십시오.",
	selectOneOrMore: '하나 이상 선택하십시오',

	relateAccountsModalTitle: 'Relate component team accounts',
	relateAccountName: 'Primary Team account:',
	relateAccountpspIndexes: 'PSP index(es):',
	relateAccountInstructionalText: 'Select account(s) from the component team\'s EY Canvas engagement listed below to relate to the selected Primary Team account.',
	pspIndexcountLabel: 'Primary/지역 팀 계정에 연결된 PSP index',
	relateAccounts: '계정 연결',

	viewComponentTeamAccountsText: 'View component team accounts not related and/or not applicable',
	componentTeamAccountsModalTitle: '연결되지 않거나 해당 없는 부문 팀 계정',
	componentTeamAccountsModalInstructionalText: "The list below displays the account(s) in the component team's EY Canvas engagement that are not related to a Primary Team account. Return to the component team reconciliation details screen to relate an account to a Primary Team account. Alternatively, if a component team account is not applicable to the group audit, mark as 'Not applicable'. <br/><br/> Marking an account 'Not applicable' will move the account to the 'Not applicable' tab. Accounts should be marked 'Not applicable' if they are not applicable to the group audit.",
	componentTeamAccountsModalNotApplicableInstructionalText: '\'Not applicable\' component team account(s) are marked this way because they are not applicable to the group audit. <br/><br/> If an account is listed below in error, select \'Undo not applicable\' to move the account to the \'Not related\' tab. Account(s) that are \'Not related\' should either be related to a Primary Team account in the Relate component team accounts modal or marked \'Not applicable\' if not applicable to the group audit.',
	notRelatedTab: '연결되지 않음',
	notApplicableTab: '해당 없음',
	unmapped: '매핑되지 않음',
	unrelate: '연결 해제',
	undoNotApplicable: 'Undo not applicable',
	action: '작업',
	notApplicableActionTitletip: "‘연결 해제’를 선택하면 위험이 ‘연결되지 않음’ 탭으로 이동됩니다. ‘연결되지 않음’인 위험은 Primary team 위험에 연결되거나, 그룹 감사에 해당하지 않는다면 ‘해당 없음’으로 표시되어야 합니다.",
	notRelatedActionTitletip: "‘해당 없음’을 선택하면 위험이 ‘해당 없음’ 탭으로 이동됩니다. ‘해당 없음’인 부문 위험은 그룹 감사에 해당하지 않습니다.",

	higherInheritRisk: '높은 고유위험',
	lowerInheritRisk: '낮은 고유위험',
	incompleteInheritRisk: 'Incomplete inherent risk',
	riskAssociated: '위험 연결됨',
	riskAssociatedHigher: '높은 고유위험에 연결되고 기여하는 위험',
	
	viewComponentTeamRisks: 'View component team risks not related and/or not applicable',
	unmappedRisksModalTitle: '연결되지 않거나 해당 없는 부문 팀 위험',
	unmappedRisksModalInstructional: 'The list below displays the risk(s) in the component team\'s EY Canvas engagement that are not related to a Primary Team risk. Return to the component team reconciliation details screen to relate a risk to a Primary Team risk. Alternatively, if a component team risk is not applicable to the group audit, mark as \'Not applicable\'. <br/><br/> Marking a risk \'Not applicable\' will move the risk to the \'Not applicable\' tab. Risks should be marked \'Not applicable\' if they are not applicable to the group audit.',
	notApplicableRisksModalInstructional: "'Not applicable' component team risk(s) are marked this way because they are not applicable to the group audit. <br/><br/> If a risk is listed below in error, select 'Undo not applicable' to move the risk to the 'Not related' tab. Risk(s) that are 'Not related' should either be related to a Primary Team risk in the Relate component team risks modal or marked 'Not applicable' if not applicable to the group audit.",
	added: '추가됨',

	groupRiskAssessmentInstructional: "The Group risk assessment Reconciliation allows the Primary Team to view the accounts and risks of material misstatement created in the component team's EY Canvas engagement.<br><br>Click on a component name below to open the component reconciliation screen where the Primary Team can relate the accounts and risks of material misstatement that were related to the component in the Primary Team's EY Canvas engagement to the accounts and risks of material misstatement that exist in the component team's EY Canvas engagement.<br><br>The Reconciliation can assist the Primary Team to identify any deviations from the group risk assessment information communicated in the group instructions, such as differences in accounts, account designations, relevant assertions, inherent risk assessments, and identified risks of material misstatement and help facilitate group involvement discussions with component teams.",
	groupRiskAssessmentActivityFeedInstructional: "The Activity feed allows the Primary Team to view any changes to the risk assessment made by the component teams in their local EY Canvas engagement. Activities highlighted include changes made in the underlying component EY Canvas engagement to accounts, account designations, assertions and identified risks of material misstatements since the creation of the EY Canvas Oversight project. This is not reflecting activity in the Reconciliation.",
	disclaimerInstructional: 'The EY Canvas Oversight Group risk assessment functionality can support effective project management by a Primary Team in a group audit. However, this functionality is not intended to provide, document or generate audit evidence. Further, it is not intended to replace the Primary Team\'s involvement in the component team\'s work, including review of component teams reporting deliverables. We do not include screenshots or data exported from EY Canvas Oversight in the Primary Team\'s EY Canvas as evidence of the Primary Team\'s involvement in, or supervision of, the work of component teams.'
};

export const temporaryLabels = {
	dryDock: 'Drydock',
	darkMode: '다크 모드',
	dashboard: '대시보드',
	projects: '프로젝트',
	scopeStrategy: '범위 및 전략',
	accountSummary: '계정 요약',
	scotSummary: 'SCOT 요약',
	craSummary: 'CRA 요약',
	itSummary: 'IT 요약',
	SPSummary: '실증절차평가 요약',
	auditPlan: '감사 계획',
	conclusion: '결론',
	findings: '발견사항',
	changesReport: '보고서일 후 변경사항',
	teamMember: '팀 멤버 독립성',
	archiveChecklist: 'Archive 체크리스트',
	enagagementmanagement: 'Engagement 관리',
	integration: '통합',
	guidedWorkflow: '가이드 업무흐름',
	copyrightMessage: 'Copyright © <year>. All rights reserved'
};

export const createGRAProjectLabels = {
	creationInstructional: "프로젝트 이름을 입력하고 아래 목록에서 Primary 또는 Regional EY Canvas engagement를 하나 선택하여 EY Oversight 프로젝트를 생성하십시오. <br>선택된 engagement에 따라, EY Canvas 그룹 구조에서 식별된 EY Canvas engagement가 자동으로 프로젝트 설정의 일부로 채워집니다. EY Canvas Oversight 관련 추가 정보를 보려면 {link}을(를) 클릭하십시오.",
	projectName: labels.projectName,
	engagements: labels.engagementsLabel,
	searchPlaceholder: 'EY Canvas engagement 이름, ID 또는 고객 이름 검색',
	noAccessToEng: '접근할 수 있는 EY Canvas engagement가 없습니다',
	noDataToDisplay: labels.noDataFound,
	save: labels.save,
	cancel: labels.cancelLabel,
	engagementsRequiredMessage: '저장할 engagement를 하나 이상 선택하십시오',
	userGuideLinkText: '사용자 가이드'
};

export const deleteCommentModalLabels ={
	titleText: 'Comment 삭제',
	instructionalText: 'Comment를 삭제하시겠습니까?',
	triggerText: '삭제',
	confirmLabel: '확인',
	cancelLabel: '취소',
	closeLabel: '닫기',
}

export const gaRoleType = [{
		id: GARoleTypeId.Primary,
		label: 'Primary'
	},
	{
		id: GARoleTypeId.Region,
		label: '지역'
	},
	{
		id: GARoleTypeId.Component,
		label: '부문'
	}
];

export const engagementTableLabels = {
	engagementName: 'Engagement 이름',
	clientName: labels.clientName,
	type: labels.typeLabel,
	gaRoleType
};

export const formLabels = {
	required: labels.required,
	maxLength: labels.formLengthMessage
};

export const activityLogTypes = {
	ProjectCreated: '프로젝트 생성일',
	GAComponentCreated: '부문 추가됨',
	GAComponentRemoved: '부문 제거됨',
	GAComponentUnlinked: '부문 링크 해제됨',
	AccountAdded: '계정 추가됨',
	AccountRemoved: '계정 제거됨',
	AccountDesignationChanged: '계정 지정 변경됨',
	AccountEstimateChanged: '계정 추정치 변경됨',
	AccountExecutionTypeChanged: '계정 실행 유형 변경됨',
	AssertionAssociated: '경영진주장 연결됨',
	AssertionUnassociated: '경영진주장 연결되지 않음',
	AssertionInherentRiskChanged: '고유위험 변경',
	AssertionControlRiskDesignationChanged: '통제위험 지정 변경',
	RiskCreated: '위험 생성됨',
	RiskRemoved: '위험 제거됨',
	RiskAssociated: '위험 연결됨',
	RiskUnassociated: '위험 연결되지 않음'
};

export const activityTableLabels = {
	sourceEngagement: '원천 engagement',
	activityType: '활동 유형',
	objectImpacted: 'Object 영향받음',
	relatedObjectImpacted: '연결된 Object 영향받음',
	relatedSecondaryObjectImpacted: '연결된 secondary object 영향받음',
	activityDate: '활동일'
};

export const regionComponentRiskTableLabels = {
	regionComponentTeamRiskName: 'Component team risk name and risk designation',
	details: '세부정보'
};

export const riskTypes = [{
		id: '1',
		label: '유의적인 위험'
	},
	{
		id: '2',
		label: '부정 위험'
	},
	{
		id: '3',
		label: '고유위험'
	}
];

export const engagementLabels = {
	accountName: '계정 / 공시 이름',
	accountTypeName: '지정',
	canvasEngagementId: 'Engagement ID',
	controlRiskTypeName: '통제 위험',
	engagementDescription: 'Engagement 이름',
	inherentRiskTypeName: '고유 위험',
	assertionName: '경영진주장',
	pspIndexTitle: 'PSP Index',
	riskName: '위험 이름',
	riskTypeName: '위험 유형',
	relatedTasks: '연결된 task',
	taskStatus: 'Task 상태',
	controlRiskAssessment: '통제위험 평가'
};

export const groupRiskAssessmentLabels = {
	activityFeed: labels.activityFeed,
	reconciliations: labels.reconciliations,
	lastRefreshed: labels.lastRefreshed,
	groupRiskAssessment: labels.groupRiskAssessment,
	lastRefreshedReconciliation: labels.lastRefreshedReconciliation,
	lastRefreshedActivityFeed: labels.lastRefreshedActivityFeed,
	groupRiskAssessmentInstructional: labels.groupRiskAssessmentInstructional,
	groupRiskAssessmentActivityFeedInstructional: labels.groupRiskAssessmentActivityFeedInstructional,
	disclaimerInstructional: labels.disclaimerInstructional
};

export const reconciliationsTableLabels = {
	show: labels.show,
	noDataToDisplay: '이 표에 표시할 데이터가 없습니다',
	unselectedEntities: '이 EY Oversight 프로젝트에 대한 조정 데이터가 없습니다. 여기에 조정 데이터를 표시하려면 Primary team EY Canvas engagement에 있는 그룹 지침 흐름에서 부문을 계정에 연결하십시오.',
	columns: {
		components: '부문',
		open: '처리 전',
		assessed: '평가됨',
		total: '합계'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const relateAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: '부문 팀 계정',
		pspIndexes: 'PSP Index'
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent,
	relateAccountTableDisabledRowToolTip: "이 부문 팀 계정은 이미 다른 Primary team 계정에 매핑됐습니다. 부문 팀 계정은 하나의 Primary team 계정에만 매핑될 수 있습니다. 해당하는 경우, 이 계정을 연결 해제하려면 관련 Primary 계정에 대해 ‘계정 연결’을 선택하십시오."
};

export const notRelatedAccountsTableLabels = {
	show: labels.show,
	noDataFound: labels.noDataFound,
	columns: {
		accountName: relateAccountsTableLabels.columns.accountName,
		pspIndexes: 'PSP Index',
		notRelated: {
			actionColumnName: labels.action,
			titleTip: '계정을 \‘해당 없음\’으로 표시하면 계정이 \‘해당 없음\’ 탭으로 이동됩니다. 계정이 그룹 감사에 해당하지 않는다면 \‘해당 없음\’으로 표시되어야 합니다.',
			actionLabel: labels.notApplicableTab
		},
		notApplicable: {
			actionColumnName: labels.action,
			titleTip: '\‘연결 해제\’를 선택하면 위험이 \‘연결되지 않음\’ 탭으로 이동됩니다. \‘연결되지 않음\’인 계정은 Primary team 계정에 연결되거나, 그룹 감사에 해당하지 않는다면 \‘해당 없음\’으로 표시되어야 합니다.',
			actionLabel: labels.undoNotApplicable
		}
	},
	nextComponent: labels.nextComponent,
	prevComponent: labels.prevComponent
};

export const unmappedRisksTableColumnLabels = {
	riskName: "부문 팀 위험",
	actions: "작업"
};

export const AdminUserErrors = {
	userError: '사용자를 찾을 수 없습니다'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: "이 작업을 수행하는 데 필요한 권한이 없습니다"
};

export const Errors = {
	106: "이 작업을 수행하는 데 필요한 권한이 없습니다",
	107: "이 작업을 수행하는 데 필요한 권한이 없습니다",
	111: '스스로에게 접근권한을 위임할 수 없습니다',
	112: '사용자를 찾을 수 없습니다',
	117: 'You cannot delegate access to an external user.',
	310: '프로젝트를 찾을 수 없습니다',
	314: '이 그룹에는 한 명 이상의 그룹 관리자를 위한 도메인이 허용되지 않습니다',
	316: '팀 멤버를 추가하려면 프로젝트 소유자 또는 그룹 관리자여야 합니다. 접근권한을 얻으려면 프로젝트 소유자와 얘기하십시오.',
	317: '내부 멤버만 프로젝트 소유자로 추가될 수 있습니다. 다음은 외부 사용자입니다: {0}. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	318: '{0}의 도메인은 다음 그룹에 허용되지 않습니다: {1}',
	319: '다른 프로젝트 소요자가 이 프로젝트를 완료했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	321: '이 작업을 완료하려면 프로젝트 소유자여야 합니다. 접근권한을 얻으려면 프로젝트 소유자와 얘기하십시오.',
	323: '다른 팀 멤버가 이 그룹을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	324: '이 프로젝트를 완료하려면 프로젝트 소유자여야 합니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	325: '이 변경을 하려면 프로젝트 소유자 또는 그룹 관리자여야 합니다. 접근권한을 얻으려면 프로젝트 소유자와 얘기하십시오.',
	326: '이 프로젝트를 저장하려면 필수 필드를 모두 완료하십시오. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	327: '프로젝트가 이미 저장됐습니다',
	328: '추가하려는 팀 멤버는 이미 이 그룹의 멤버입니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	330: '마지막 프로젝트 소유자는 삭제할 수 없습니다',
	331: '다른 팀 멤버가 하나 이상의 그룹을 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	332: '프로젝트 소유자가 하나 이상 있어야 합니다. 이 프로젝트에서 귀하 자신을 제거할 수 없습니다.',
	341: '선택한 고객이나 engagement에 접근권한이 없습니다',
	343: '활성 및 초안 프로젝트만 삭제할 수 있습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	344: '이 프로젝트를 삭제하려면 귀하가 프로젝트 소유자여야 합니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	345: '다른 팀 멤버가 이 프로젝트를 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	346: '다른 프로젝트 소유자 또는 기업 관리자가 이미 {0}에 대한 접근을 검토했습니다. 접근 로그를 새로 고침하여 다시 시도하십시오.',
	347: '이 프로젝트에서 연락처를 추가하거나 제거하려면 프로젝트 소유자 또는 기업 관리자여야 합니다. 접근권한을 요청하려면 프로젝트 소유자에게 얘기하십시오.',
	348: '귀하가 관리하는 기업의 연락처만 제거할 수 있습니다. 다음 연락처는 귀하가 관리자가 아니며 제거할 수 없는 기업에 속합니다: {0}.',
	360: '이 작업을 완료하려면 이 프로젝트 소유자여야 합니다',
	361: '이 작업을 하려면 프로젝트 소유자 또는 기업 관리자여야 합니다. 접근권한을 요청하려면 프로젝트 소유자에게 얘기하십시오.',
	362: '귀하가 관리하는 기업 소속 연락처에 대한 접근권한만 관리할 수 있습니다. 다음 연락처는 귀하가 관리하는 기업 소속이 아니며 접근권한을 편집할 없습니다: {0}.',
	364: '이 프로젝트에서 제거된 하나 이상의 연락처에 대해 접근권한을 편집하려고 합니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	365: '이 프로젝트에서 제거된 하나 이상의 연락처에 대해 정보를 편집하려고 합니다: {0} 페이지를 새로 고침하여 다시 시도하십시오',
	366: '귀하가 관리하는 기업 소속 연락처에 대한 정보만 편집할 수 있습니다. 다음 연락처는 귀하가 관리하는 기업 소속이 아닙니다: {0}',
	367: '편집하고 있는 사용자지정 열을 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	368: '편집하고 있는 사용자지정 열 옵션을 다른 팀 멤버가 삭제했습니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	369: '이 작업을 하려면 프로젝트 소유자여야 합니다',
	370: '귀하가 관리하는 기업 소속 연락처의 속성만 편집할 수 있습니다. 다음 연락처는 귀하가 관리하는 기업 소속이 아닙니다: {0}',
	372: '이 작업을 하려면 프로젝트 소유자여야 합니다',
	373: '연락처 목록 페이지에서 프로젝트 소유자를 삭제할 수 없습니다. 요청 작업을 하려면 project wizard로 이동하십시오',
	374: '귀하는 이 프로젝트에서 프로젝트 소유자인 자신을 제거할 수 없습니다',
	375: '프로젝트에서 마지막 프로젝트 소유자를 제거할 수 없습니다. 프로젝트 소유자가 한 명 이상 남아 있어야 합니다.',
	376: '귀하는 프로젝트에서 프로젝트 소유자나 기업 관리자를 추가/제거할 수 있는 프로젝트 소유자여야 합니다. 다음 연락처를 제거할 수 없습니다: {0}',
	378: '이 Oversight 프로젝트의 연락처 목록 페이지에 있는 연락처에서 사용 중인 도메인은 제거할 수 없습니다. 연락처 목록 페이지로 가서 이 도메인이 있는 연락처를 제거한 후, 여기로 돌아와 도메인을 제거하십시오.',
	502: 'Engagement 가져오기 호출 실패. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	503: '선택한 고객에 접근권한이 없습니다',
	601: '고객 가져오기 호출 실패. 페이지를 새로 고침하여 다시 시도하십시오. 오류가 지속되면 헬프 데스크에 문의하십시오.',
	1605: '선택된 사용자가 이미 존재합니다',

	1803: '태그 작업이 유효하지 않은 프로젝트 데이터로 수행되었습니다. 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 추가 지원을 위해 헬프 데스크에 문의하십시오.',
	1804: '이 태그 작업을 수행하려면 이 프로젝트 소유자여야 합니다',
	1901: '메시지 전송 API 호출 실패',
	1902: '메시지는 비워둘 수 없습니다',
	1903: '허용된 메시지 길이는 200자 입니다',
	1904: '허용된 회신 텍스트 길이는 50자 입니다',
	1905: '허용된 회신 uri 길이는 50자 입니다',
	1906: '계속하려면 필터를 하나 이상 선택해야합니다',
	1907: '수신자는 중복될 수 없습니다',
	1908: 'Engagement는 비워둘 수 없습니다',
	1909: '메시지 유형이 유효한 값이 아닙니다',
	1910: '수신자는 빈 값일 수 없습니다',
	1911: '토스트 메시지는 비워둘 수 없습니다',
	1912: '수신자 유형이 유효한 값이 아닙니다',
	1913: '알림을 전송하는 데 적합한 접근권한이 없습니다. 접근권한을 요청하려면 프로젝트 소유자 또는 기업 관리자에게 얘기하십시오.',
	1914: '알림은 내부 연락처로만 전송할 수 있습니다. 계속하려면 메시지 수신자를 검토하여 외부 연락처를 제거하십시오.',
	2101: '지금은 EY 정책 작성, 승인 및 알림 서비스를 사용할 수 없습니다. 따라서 관련 정책이 모두 완료됐는지 확인할 수 없습니다. 관련 정책을 검토하지 않았다면, 페이지를 새로 고침하여 다시 시도하십시오. 문제가 지속되면 헬프 데스크에 문의하십시오.',

	// Reconciliation
	2701: '모든 조정 가져오기 호출 실패',
	2702: '유효하지 않은 요청',
	2703: 'ID별 조정 가져오기 호출 실패',
	2704: 'ID별 위험 가져오기 호출 실패',
	2705: "프로젝트를 '데이터베이스에서 찾을 수 없습니다",
	2706: '계정을 데이터베이스에서 찾을 수 없습니다',
	2707: 'Engagement를 데이터베이스에서 찾을 수 없습니다',
	2708: 'Comment 생성 호출 실패',
	2709: 'Comment가 이미 생성되어 있습니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	2710: '그룹 부문 계정 패치 호출 실패',
	2711: '그룹 부문 계정을 데이터베이스에서 찾을 수 없습니다',
	2712: '근거 comment는 비워둘 수 없습니다',
	2713: '근거 comment는 4,000자를 초과할 수 없습니다',
	2714: '그룹 부문 위험을 찾을 수 없습니다',
	2715: '그룹 부문을 찾을 수 없습니다',
	2716: 'Risk was not found.',
	2717: 'Invalid group risk status value.',
	2718: '조정 업데이트 호출 실패',
	2719: 'Patch group component risk comment call failed. Refresh the page and try again.',
	2720: '다른 사용자가 이 항목을 이미 편집하거나 삭제했습니다. 새로 고침하여 다시 시도하십시오.',
	2721: 'Comment가 이미 생성되어 있습니다. 페이지를 새로 고침하여 다시 시도하십시오.',
	2722: 'Account is deleted.'
};

export const clientValidationErrors = {
	ErrorAtleastOneEngagementAssociationRequired: '계속하려면 조직도에 engagement를 하나 이상 연결하십시오',
	ErrorAtleastOneGroupAssociationRequired: '계속하려면 조직도에 그룹을 하나 이상 연결하십시오',
	ErrorStep2DataNotComplete: '계속하려면 조직도에 있는 각 기업 이름을 입력하십시오'
};

export const engagementsViewBy = [{
		id: 0,
		label: '모두',
		value: '모두'
	},
	{
		id: 1,
		label: '국가별',
		value: '국가',
		groupAttributeName: '국가 이름'
	},
	{
		id: 2,
		label: 'Primary office 기준',
		value: 'Region별',
		groupAttributeName: 'Region 이름'
	},
	{
		id: 3,
		label: 'Engagement 유형별',
		value: '유형',
		groupAttributeName: 'profileNature'
	}
];

export const milestones = [{
		id: 1,
		label: '범위',
		auditPhaseId: 1,
		value: 1
	},
	{
		id: 2,
		label: '전략',
		auditPhaseId: 1,
		value: 2
	},
	{
		id: 3,
		label: 'Walkthrough',
		auditPhaseId: 2,
		value: 3
	},
	{
		id: 4,
		label: '중간 통제테스트',
		auditPhaseId: 2,
		value: 4
	},
	{
		id: 5,
		label: '중간 실증 테스트',
		auditPhaseId: 2,
		value: 5
	},
	{
		id: 6,
		label: 'Walkthrough (기말 프로세스)',
		auditPhaseId: 2,
		value: 6
	},
	{
		id: 7,
		label: '기말 통제테스트',
		auditPhaseId: 2,
		value: 7
	},
	{
		id: 8,
		label: '기말 실증 테스트',
		auditPhaseId: 2,
		value: 8
	},
	{
		id: 9,
		label: '결론',
		auditPhaseId: 3,
		value: 9
	},
	{
		id: 10,
		label: 'N/A',
		auditPhaseId: 2,
		value: 10
	},
	{
		id: 11,
		label: '실행',
		auditPhaseId: 2,
		value: 11
	},
	{
		id: 12,
		label: '범위 및 전략 품질 활동',
		auditPhaseId: 1,
		value: 12
	},
	{
		id: 13,
		label: '기타 범위 및 전략',
		auditPhaseId: 1,
		value: 13
	},
	{
		id: 14,
		label: 'CRA',
		auditPhaseId: 1,
		value: 14
	},
	{
		id: 15,
		label: '위험 평가 및 중요성',
		auditPhaseId: 1,
		value: 15
	},
	{
		id: 16,
		label: '범위 및 전략 마무리',
		auditPhaseId: 1,
		value: 16
	},
	{
		id: 17,
		label: '중간감사 후 프로젝트 관리',
		auditPhaseId: 2,
		value: 17
	}
];

export const daysOptions = [{
		id: daySelection.tomorrow,
		value: daySelection.tomorrow,
		label: '내일'
	},
	{
		id: daySelection.next3days,
		value: daySelection.next3days,
		label: '다음 3일'
	},
	{
		id: daySelection.next5days,
		value: daySelection.next5days,
		label: '다음 5일'
	},
	{
		id: daySelection.next10days,
		value: daySelection.next10days,
		label: '다음 10일'
	},
	{
		id: daySelection.next30days,
		value: daySelection.next30days,
		label: '다음 30일'
	}
];

export const auditPhases = [{
		id: 1,
		label: '범위 및 전략'
	},
	{
		id: 2,
		label: '실행'
	},
	{
		id: 3,
		label: '결론'
	}
];

export const findings = [{
		id: 1,
		label: '왜곡표시',
		subTitle: '유형별 왜곡표시'
	},
	{
		id: 2,
		label: '미비점',
		subTitle: '심각성별 미비점'
	}
];
export const risks = [{id: 1, label: '', subTitle: 'By type'}];

export const auditStrategies = [{
		id: 1,
		label: '실증',
		subTitle: '유형별 실증절차'
	},
	{
		id: 2,
		label: '통제',
		subTitle: '테스트 전략별 통제'
	},
	{
		id: 3,
		label: 'IT',
		subTitle: '테스트 전략별 IT 절차'
	}
];

export const auditInsights = [{
		id: 1,
		label: '그룹 역할별'
	},
	{
		id: 2,
		label: '모두'
	}
];

export const projectStatus = {
	Active: '활동',
	Draft: '초안',
	Cancel: '취소',
	Complete: '완료됨',
	Delete: '삭제'
};

export const ProjectStatusLabels = [{
		label: '이니셜',
		id: 1,
		value: 'Initial'
	},
	{
		label: '초안',
		id: 2,
		value: 'Draft'
	},
	{
		label: '활동',
		id: 3,
		value: 'Active'
	},
	{
		label: '취소됨',
		id: 4,
		value: 'Cancelled'
	},
	{
		label: '완료됨',
		id: 5,
		value: 'Completed'
	},
	{
		label: '삭제됨',
		id: 6,
		value: 'Delete'
	}
];

export const projectTeamEngagementTableGroup = [{
		id: 1,
		label: '작성자 배정'
	},
	{
		id: 2,
		label: '검토자 배정'
	}
];

export const archiveReportQualifiedType = [{
		id: archiveReportQualifiedTypeId.notSelected,
		label: '미선택'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithEmphasisOfMatter,
		label: '적정 - 강조사항 있음'
	},
	{
		id: archiveReportQualifiedTypeId.unqualifiedWithoutEmphasisOfMatter,
		label: '적정 - 강조사항 없음'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithEmphasisOfMatter,
		label: '한정 - 강조사항 있음'
	},
	{
		id: archiveReportQualifiedTypeId.qualifiedWithoutEmphasisOfMatter,
		label: '한정 - 강조사항 없음'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithEmphasisOfMatter,
		label: '부적정 - 강조사항 있음'
	},
	{
		id: archiveReportQualifiedTypeId.adverseOpinionWithoutEmphasisOfMatter,
		label: '부적정 - 강조사항 없음'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithEmphasisOfMatter,
		label: '의견거절 - 강조사항 있음'
	},
	{
		id: archiveReportQualifiedTypeId.disclaimerOfOpinionWithoutEmphasisOfMatter,
		label: '의견거절 - 강조사항 없음'
	}
];

export const strategyTableGroup = [{id: 1, label: ''}];

export const roleForMember = [{
		id: roles.partnerInCharge,
		label: 'Partner in Charge',
		roleAbbreviation: 'PTR IN CHG'
	},
	{
		id: roles.engagementPartner,
		label: 'Engagement Partner',
		roleAbbreviation: 'EP'
	},
	{
		id: roles.executiveDirector,
		label: 'Executive Director',
		roleAbbreviation: 'EXEC DIR'
	},
	{
		id: roles.principal,
		label: 'Principal',
		roleAbbreviation: 'PRINCIPAL'
	},
	{
		id: roles.seniorManager,
		label: 'Senior Manager',
		roleAbbreviation: 'SR.MANAGER'
	},
	{
		id: roles.manager,
		label: 'Manager',
		roleAbbreviation: 'MANAGER'
	},
	{
		id: roles.senior,
		label: 'Senior',
		roleAbbreviation: 'SENIOR'
	},
	{
		id: roles.staff,
		label: 'Staff',
		roleAbbreviation: 'STAFF'
	},
	{
		id: roles.intern,
		label: 'Intern',
		roleAbbreviation: 'Intrn'
	},
	{
		id: roles.engagementQualityReviewer,
		label: 'Engagement Quality Reviewer',
		roleAbbreviation: 'EQR'
	},
	{
		id: roles.otherPartner,
		label: 'Other Partner',
		roleAbbreviation: 'OTHER PTR'
	},
	{
		id: roles.gdsStaff,
		label: 'GDS - Staff',
		roleAbbreviation: 'GDS-STAFF'
	},
	{
		id: roles.advisory,
		label: 'Advisory (ITRATASHuman Capital or Other)',
		roleAbbreviation: 'ADV'
	},
	{
		id: roles.tax,
		label: 'Tax',
		roleAbbreviation: 'Tax'
	},
	{
		id: roles.executiveSupportServices,
		label: 'Executive Support Services',
		roleAbbreviation: 'ESS'
	},
	{
		id: roles.generalCounsel,
		label: 'General Counsel',
		roleAbbreviation: 'GCO'
	},
	{
		id: roles.auditQualityReviewer,
		label: 'Audit Quality Reviewer',
		roleAbbreviation: 'AQR'
	},
	{
		id: roles.mlComponentTeam,
		label: 'ML Component Team',
		roleAbbreviation: 'MCT'
	},
	{
		id: roles.clientSupervisor,
		label: 'Client Supervisor',
		roleAbbreviation: 'ClntS'
	},
	{
		id: roles.clientStaff,
		label: 'Client Staff',
		roleAbbreviation: 'ClntSt'
	},
	{
		id: roles.internalAuditSupervisor,
		label: 'Internal Audit Supervisor',
		roleAbbreviation: 'IASup'
	},
	{
		id: roles.internalAuditStaff,
		label: 'Internal Audit Staff',
		roleAbbreviation: 'IASt'
	},
	{
		id: roles.regulator,
		label: 'Regulator',
		roleAbbreviation: 'Reglr'
	},
	{
		id: roles.other,
		label: 'Other (e.g. due diligence review)',
		roleAbbreviation: 'Otrs'
	},
	{
		id: roles.office,
		label: 'Office',
		roleAbbreviation: 'Off'
	},
	{
		id: roles.area,
		label: 'Area',
		roleAbbreviation: 'Area'
	},
	{
		id: roles.industry,
		label: 'Industry',
		roleAbbreviation: 'IND'
	},
	{
		id: roles.national,
		label: 'National',
		roleAbbreviation: 'NAT'
	},
	{
		id: roles.global,
		label: 'Global',
		roleAbbreviation: 'GBL'
	},
	{
		id: roles.gsdSenior,
		label: 'GDS - Senior',
		roleAbbreviation: 'GDS-SENIOR'
	},
	{
		id: roles.gsdManager,
		label: 'GDS - Manager',
		roleAbbreviation: 'GDS-MANAGER'
	}
];

export const toggleCCPEntityOptions = [{
		id: toggleCCPEntityDetail.comingDue,
		label: labels.comingDue
	},
	{
		id: toggleCCPEntityDetail.overdue,
		label: labels.taskStatusOverdue
	},
	{
		id: toggleCCPEntityDetail.returned,
		label: labels.returned
	}
];

export const reportReadinessSeries = [
	{id: readinessReportCategories.comingDueOver2Weeks, label: `> 2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.comingDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDueUnder1Week, label: `< 1{break}${labels.week}`},
	{id: readinessReportCategories.overDue12Weeks, label: `1-2{break}${labels.weeks}`},
	{id: readinessReportCategories.overDueOver2Weeks, label: `> 2{break}${labels.weeks}`}
];

export const natureOfEngagementsLabels = {
	[natureOfEngagements.auditStatements.id]: '재무제표 감사',
	[natureOfEngagements.integratedStatements.id]: '재무제표와 재무보고에 대한 내부통제 통합 감사',
	[natureOfEngagements.reviewStatements.id]: '중간재무제표 검토',
	[natureOfEngagements.nonAuditAccount.id]: '계정/경영진주장/SCOT 기능이 포함된 비감사 engagement',
	[natureOfEngagements.nonAuditWorkPlan.id]: '작업계획 기능만 포함된 비감사 engagement'
};

export const AdminRoles = [{
		label: 'Application 관리 판독자',
		id: 1
	},
	{
		label: 'Application 관리 작성자',
		id: 2
	},
	{
		label: 'Application 수퍼 관리자',
		id: 3
	}
];

export const userType = [{
		value: 1,
		label: '내부'
	},
	{
		value: 2,
		label: '외부'
	}
];

export const MessageType = [{
		value: 1,
		label: '이메일'
	},
	{
		value: 2,
		label: '알림'
	}
];

export const groupRole = [{
		value: 1,
		label: 'Primary team',
		id: 1,
		selected: false,
		disabled: false
	},
	{
		value: 2,
		label: '지역 팀',
		id: 2,
		selected: false,
		disabled: false
	},
	{
		value: 3,
		label: '부문 팀',
		id: 3,
		selected: false,
		disabled: false
	},
	{
		value: 4,
		label: '비EY 감사인에게 보고하는 부문 팀',
		id: 4,
		selected: false,
		disabled: false
	},
	{
		value: 5,
		label: '해당 없음',
		id: 5,
		selected: false,
		disabled: false
	}
];

export const accessLogResource = [{
		id: 1,
		label: '추가할 연락처'
	},
	{
		id: 2,
		label: 'Contacts to remove'
	}
];

export const addContactsTabsResource = [{
		id: 1,
		label: '접근'
	},
	{
		id: 2,
		label: '정보'
	},
	{
		id: 3,
		label: '태그'
	}
];

export const tags = [{
		name: 'Audit partner',
		id: 'auditPartner'
	},
	{
		name: 'Audit engagement manager',
		id: 'auditEngagementManager'
	},
	{
		name: 'GDS engagement manager',
		id: 'gdsEngagementManager'
	},
	{
		name: 'Tax partner',
		id: 'taxPartner'
	},
	{
		name: 'Tax engagement manager',
		id: 'taxEngagementManager'
	},
	{
		name: 'FAIT partner',
		id: 'faitPartner'
	},
	{
		name: 'FAIT engagement manager',
		id: 'faitEngagementManager'
	},
	{
		name: 'Advisory partner',
		id: 'advisoryPartner'
	},
	{
		name: 'Advisory engagement manager',
		id: 'advisoryEngagementManager'
	},
	{
		name: 'Specialist',
		id: 'specialist'
	},
	{
		name: '고객 관리자',
		id: 'clientadministrator'
	}
];

export const dashboardContactViews = [{
		id: dashboardTabId.milestones,
		value: dashboardViewsConstants.milestones,
		tooltipText: 'Milestone별 감사 진행상황',
		key: 'Milestone',
		checked: false
	},
	{
		id: dashboardTabId.projectManagement,
		value: dashboardViewsConstants.projectManagement,
		tooltipText: '리뷰노트 및 배정 상태, 지연 항목 포함. 외부 사용자는 프로젝트 관리 대시보드 접근권한을 부여받을 수 없습니다.',
		key: '프로젝트 관리',
		checked: false
	},
	{
		id: dashboardTabId.groupAudit,
		value: dashboardViewsConstants.groupAudit,
		tooltipText: 'Primary 및 부문 팀 상태. 반송, 지연 항목 포함.',
		key: '그룹 감사',
		checked: false
	},
	{
		id: dashboardTabId.groupRiskAssessment,
		value: dashboardViewsConstants.groupRiskAssessment,
		tooltipText: 'Primary와 부문 팀 전체의 그룹 위험 평가 보기. 이 보기는 고객에게 보이지 않습니다.',
		key: '그룹 위험 평가',
		checked: false
	},
	{
		id: dashboardTabId.canvasClientPortal,
		value: dashboardViewsConstants.ccp,
		tooltipText: '요청 상태. 만료 도래, 지연, 반송 항목 포함.',
		key: 'EY Canvas Client Portal',
		checked: false
	},
	{
		id: dashboardTabId.insights,
		value: dashboardViewsConstants.insights,
		tooltipText: 'Primary 및 부문 팀 간 위험, 실증절차, 통제 전략, 발견사항 비교. 외부 사용자는 인사이트 대시보드 접근권한을 부여받을 수 없습니다.',
		key: '인사이트',
		checked: false
	},
	{
		id: dashboardTabId.reporting,
		value: dashboardViewsConstants.reporting,
		tooltipText: '국가별 보고서 준비, 수정, task 완료 상태',
		key: '보고',
		checked: false
	}
];

export const colorOptionsLabels = {
	red: '빨간색',
	orange: '귤색',
	teal: '청록색',
	blue: '파란색',
	purple: '보라색',
	green: '녹색',
	yellow: '노란색',
	gray: '회색'
};

export const exportToExcelLabels = {
	yes: '예',
	no: '아니오',
	exportData: labels.exportData,
	exportButtonTitle: '이 EY Oversight 프로젝트의 왼쪽 레일에 있는 조직도에서 선택된 기업에 대한 세부 고객 요청 정보를 다운로드하려면 여기를 클릭하십시오',
	projectInfo: '프로젝트 정보',
	exportDate: '내보낸 날짜',
	engagementName: labels.engagementNameLabel,
	engagementId: labels.engagementId,
	requestItemNumber: '요청 항목 번호',
	requestTitle: '요청 제목',
	priority: '우선순위',
	status: labels.status,
	receivedDate: '수신일',
	dueDate: '만료일',
	overdue: labels.overdueLabel,
	eyContact: 'EY 연락처',
	assignedTo: '담당자',
	statusLabels: [{
			id: 1,
			label: '초안'
		},
		{
			id: 2,
			label: '고객 연락처 없음'
		},
		{
			id: 3,
			label: '전송됨'
		},
		{
			id: 4,
			label: '시스템 오류'
		},
		{
			id: 5,
			label: '유효하지 않은 고객 연락처'
		},
		{
			id: 6,
			label: '응답 보류 중'
		},
		{
			id: 7,
			label: '수신됨'
		},
		{
			id: 8,
			label: '수락됨'
		},
		{
			id: 9,
			label: '반송됨'
		},
		{
			id: 10,
			label: '철회됨'
		},
		{
			id: 11,
			label: '전송 진행 중'
		},
		{
			id: 12,
			label: '수락 진행 중'
		},
		{
			id: 13,
			label: '철회 진행 중'
		},
		{
			id: 14,
			label: '삭제 진행 중'
		},
		{
			id: 15,
			label: '반송 진행 중'
		},
		{
			id: 16,
			label: '응답 진행 중'
		},
		{
			id: 17,
			label: '삭제됨'
		},
		{
			id: 18,
			label: '유효하지 않은 고객 연락처 반송됨'
		},
		{
			id: 19,
			label: '회수 진행 중'
		},
		{
			id: 20,
			label: '회수됨'
		},
		{
			id: 21,
			label: '완료 진행 중'
		},
		{
			id: 22,
			label: '회수 진행 중'
		}
	],
	priorityTypeLabels: [{
			id: 1,
			label: 'Low'
		},
		{
			id: 2,
			label: 'Medium'
		},
		{
			id: 3,
			label: 'High'
		},
		{
			id: 4,
			label: 'Critical'
		}
	],

	risks: {
		exportButtonTitle: '이 EY Oversight 프로젝트의 왼쪽 레일에 있는 조직도에서 선택된 기업에 대한 세부 위험평가 데이터를 다운로드하려면 여기를 클릭하십시오',
		tabTitle: '위험평가 세부정보',
		columns: {
			engagementName: labels.engagementNameLabel,
			engagementId: labels.engagementId,
			accountName: '계정 / 공시 이름',
			pspIndex: 'PSP Index',
			accountType: '지정',
			assertion: '경영진주장',
			inherentRisk: '고유 위험',
			controlRisk: '통제 위험',
			craValue: '통제위험 평가',
			riskType: '위험 유형',
			riskName: '위험 이름',
			relatedTasks: '연결된 task',
			taskStatus: 'Task 상태'
		}
	},
	exportButtonTooltip: 'Primary team 및 연결된 부문 팀에 대한 세부 조정 데이터를 다운로드하려면 여기를 클릭하십시오',
	primaryTeamEngagementName: 'Primary team engagement 이름',
	componentTeamEngagementName: '부문 팀 engagement 이름',
	howToUseThisExport: '이 내보내기 사용법:',
	howToUseThisExportText: 'The information in the "Accounts" and "Risks" tabs of this excel file summarizes the ​reconciliation of the accounts and risks included in the Primary Team group risk assessment communication to the accounts and risks existing in the component EY Canvas engagement.\n On the "Accounts" tab, we are displaying the list of relevant Primary and component team accounts. In addition, we are displaying the details of each Primary and component team account, including account name, associated PSP index(es), account designation and the associated assertions. If Primary and component team account(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team account(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.\n On the "Risks" tab, we are displaying the list of relevant Primary and component team risks. In addition, we are displaying the details of each Primary and component team risk, including risk name, risk designation, accounts related to the risks and the associated PSP index(es) to the accounts. If Primary and component team risk(s) have been related or marked assessed in Oversight - Reconciliation data, the Primary team and component team risk(s) rows below will be grouped together. Additionally, comments left in Oversight - Reconciliation data will be reflected below.',
	reconciliationComponentExportTabTitle: '계정',
	reconciliationComponentExport: {
		status: '상태',
		primaryTeamAccountName: 'Primary Team account name',
		componentTeamAccountNames: '부문 팀 계정 이름',
		pspIndexes: 'PSP Index',
		designation: '지정',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'Comment'
	},
	groupRiskStatusLabels : {
		[groupRiskStatus.open]: "처리 전",
		[groupRiskStatus.assessed]: "평가됨",
		[groupRiskStatus.mapped]: "매핑됨",
		[groupRiskStatus.unmapped]: "매핑되지 않음",
		[groupRiskStatus.notApplicable]: "해당 없음",
		[groupRiskStatus.systemReOpened]: "Open"
	},
	reconciliationExportTabRisks: 'Risks',
	reconciliationExport: {
		status: '상태',
		primaryTeamRiskName: 'Primary team risk name',
		componentTeamRiskName: 'Component team risk name(s)',
		riskDesignation: 'Risk designation',
		accountsRelatedToRisk: 'Account(s) related to risk',
		c: 'C',
		eo: 'E/O',
		mv: 'M/V',
		ro: 'R&O',
		pd: 'P&D',
		comment: 'Comment'
	}
};

export const accountDesignationsLabels = {
	[accountDesignations.significantAccount]: 'Significant account',
	[accountDesignations.limitedRiskAccount]: 'Limited risk account',
	[accountDesignations.insignificantAccount]: '비유의적',
	[accountDesignations.otherAccount]: '기타',
	[accountDesignations.significantDisclosure]: '유의적인 공시'
};

export const riskDesignationsLabels = {
	[riskTypeIds.significant]: 'Significant Risk',
	[riskTypeIds.fraud]: 'Fraud Risk',
	[riskTypeIds.insignificant]: 'Insignificant Risk'
};
